// source: ClientServer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.ClientServer.Error', null, global);
goog.exportSymbol('proto.ClientServer.GameCommandRequest', null, global);
goog.exportSymbol('proto.ClientServer.GameCommandRequest.RequestCase', null, global);
goog.exportSymbol('proto.ClientServer.GameCommandResponse', null, global);
goog.exportSymbol('proto.ClientServer.GameCommandResponse.ResponseCase', null, global);
goog.exportSymbol('proto.ClientServer.GameSubscribeRequest', null, global);
goog.exportSymbol('proto.ClientServer.GameSubscribeResponse', null, global);
goog.exportSymbol('proto.ClientServer.GameSubscribeResponse.SubscribeCase', null, global);
goog.exportSymbol('proto.ClientServer.Notification', null, global);
goog.exportSymbol('proto.ClientServer.Notification.NotificationCase', null, global);
goog.exportSymbol('proto.ClientServer.PingRequest', null, global);
goog.exportSymbol('proto.ClientServer.PingResponse', null, global);
goog.exportSymbol('proto.ClientServer.PlayerBalanceChangeNotification', null, global);
goog.exportSymbol('proto.ClientServer.PlayerBalanceChangeNotification.Reason', null, global);
goog.exportSymbol('proto.ClientServer.PlayerBalanceRequest', null, global);
goog.exportSymbol('proto.ClientServer.PlayerBalanceResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameRoom', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameRoom.BackgammonRoom', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonAction', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonState', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameRoom.PokerRoom', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameRoom.PokerRoom.PokerState', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameRoom.RoomCase', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameRoom.RoomType', null, global);
goog.exportSymbol('proto.ClientServer.PvpGameSubscribeResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesAcceptInvitationRequest', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesAcceptInvitationResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.DoublingAction', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesBackgammonMoveRequest', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesBackgammonMoveResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesBackgammonRollRequest', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesBackgammonRollResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesDecisionMadeNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesDecisionMadeNotification.NotificationCase', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesDecisionWaitNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesDecisionWaitNotification.NotificationCase', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesExitRoomRequest', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesExitRoomResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesInvitationReceivedNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesInvitationResponseNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesInviteOpponentRequest', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesInviteOpponentResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesKickoutNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesListRoomsRequest', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesListRoomsResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesListTournamentsRequest', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesListTournamentsResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesListTournamentsResponse.Tournament', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesListUsersRequest', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesListUsersResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesPlayRoomRequest', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesPlayRoomResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesPlayerJoinNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesPokerBetRequest', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesPokerBetResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesRoomNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesRoomNotification.NotificationCase', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesRoomTerminatedNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesStateNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesWatchRoomRequest', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesWatchRoomResponse', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesWinNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification', null, global);
goog.exportSymbol('proto.ClientServer.PvpGamesWinNotification.NotificationCase', null, global);
goog.exportSymbol('proto.ClientServer.Request', null, global);
goog.exportSymbol('proto.ClientServer.Request.ClientType', null, global);
goog.exportSymbol('proto.ClientServer.Request.MessageType', null, global);
goog.exportSymbol('proto.ClientServer.Request.RequestCase', null, global);
goog.exportSymbol('proto.ClientServer.Response', null, global);
goog.exportSymbol('proto.ClientServer.Response.ResponseCase', null, global);
goog.exportSymbol('proto.ClientServer.SessionLoginRequest', null, global);
goog.exportSymbol('proto.ClientServer.SessionLoginRequest2', null, global);
goog.exportSymbol('proto.ClientServer.SessionLoginResponse', null, global);
goog.exportSymbol('proto.ClientServer.SetPlayerPrefsRequest', null, global);
goog.exportSymbol('proto.ClientServer.SetPlayerPrefsResponse', null, global);
goog.exportSymbol('proto.ClientServer.UserDisconnectNotification', null, global);
goog.exportSymbol('proto.ClientServer.UserDisconnectNotification.Reason', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.SessionLoginRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.SessionLoginRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.SessionLoginRequest.displayName = 'proto.ClientServer.SessionLoginRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.SessionLoginRequest2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.SessionLoginRequest2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.SessionLoginRequest2.displayName = 'proto.ClientServer.SessionLoginRequest2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.SessionLoginResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.SessionLoginResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.SessionLoginResponse.displayName = 'proto.ClientServer.SessionLoginResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PlayerBalanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PlayerBalanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PlayerBalanceRequest.displayName = 'proto.ClientServer.PlayerBalanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PlayerBalanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PlayerBalanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PlayerBalanceResponse.displayName = 'proto.ClientServer.PlayerBalanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.GameSubscribeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.GameSubscribeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.GameSubscribeRequest.displayName = 'proto.ClientServer.GameSubscribeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGameRoom = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ClientServer.PvpGameRoom.oneofGroups_);
};
goog.inherits(proto.ClientServer.PvpGameRoom, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGameRoom.displayName = 'proto.ClientServer.PvpGameRoom';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGameRoom.PokerRoom = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGameRoom.PokerRoom.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGameRoom.PokerRoom, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGameRoom.PokerRoom.displayName = 'proto.ClientServer.PvpGameRoom.PokerRoom';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.displayName = 'proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGameRoom.BackgammonRoom.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGameRoom.BackgammonRoom, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGameRoom.BackgammonRoom.displayName = 'proto.ClientServer.PvpGameRoom.BackgammonRoom';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.displayName = 'proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.displayName = 'proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGameSubscribeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGameSubscribeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGameSubscribeResponse.displayName = 'proto.ClientServer.PvpGameSubscribeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.GameSubscribeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ClientServer.GameSubscribeResponse.oneofGroups_);
};
goog.inherits(proto.ClientServer.GameSubscribeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.GameSubscribeResponse.displayName = 'proto.ClientServer.GameSubscribeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesListUsersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesListUsersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesListUsersRequest.displayName = 'proto.ClientServer.PvpGamesListUsersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesListUsersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGamesListUsersResponse.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGamesListUsersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesListUsersResponse.displayName = 'proto.ClientServer.PvpGamesListUsersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesInviteOpponentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesInviteOpponentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesInviteOpponentRequest.displayName = 'proto.ClientServer.PvpGamesInviteOpponentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesInviteOpponentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesInviteOpponentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesInviteOpponentResponse.displayName = 'proto.ClientServer.PvpGamesInviteOpponentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesListTournamentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesListTournamentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesListTournamentsRequest.displayName = 'proto.ClientServer.PvpGamesListTournamentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesListTournamentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGamesListTournamentsResponse.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGamesListTournamentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesListTournamentsResponse.displayName = 'proto.ClientServer.PvpGamesListTournamentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesListTournamentsResponse.Tournament, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.displayName = 'proto.ClientServer.PvpGamesListTournamentsResponse.Tournament';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesAcceptInvitationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesAcceptInvitationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesAcceptInvitationRequest.displayName = 'proto.ClientServer.PvpGamesAcceptInvitationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesAcceptInvitationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesAcceptInvitationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesAcceptInvitationResponse.displayName = 'proto.ClientServer.PvpGamesAcceptInvitationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesListRoomsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesListRoomsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesListRoomsRequest.displayName = 'proto.ClientServer.PvpGamesListRoomsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesListRoomsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGamesListRoomsResponse.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGamesListRoomsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesListRoomsResponse.displayName = 'proto.ClientServer.PvpGamesListRoomsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesWatchRoomRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesWatchRoomRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesWatchRoomRequest.displayName = 'proto.ClientServer.PvpGamesWatchRoomRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesWatchRoomResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesWatchRoomResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesWatchRoomResponse.displayName = 'proto.ClientServer.PvpGamesWatchRoomResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesPlayRoomRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesPlayRoomRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesPlayRoomRequest.displayName = 'proto.ClientServer.PvpGamesPlayRoomRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesPlayRoomResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesPlayRoomResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesPlayRoomResponse.displayName = 'proto.ClientServer.PvpGamesPlayRoomResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesExitRoomRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesExitRoomRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesExitRoomRequest.displayName = 'proto.ClientServer.PvpGamesExitRoomRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesExitRoomResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesExitRoomResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesExitRoomResponse.displayName = 'proto.ClientServer.PvpGamesExitRoomResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesPokerBetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesPokerBetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesPokerBetRequest.displayName = 'proto.ClientServer.PvpGamesPokerBetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesPokerBetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesPokerBetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesPokerBetResponse.displayName = 'proto.ClientServer.PvpGamesPokerBetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesBackgammonRollRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGamesBackgammonRollRequest.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGamesBackgammonRollRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesBackgammonRollRequest.displayName = 'proto.ClientServer.PvpGamesBackgammonRollRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesBackgammonRollResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGamesBackgammonRollResponse.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGamesBackgammonRollResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesBackgammonRollResponse.displayName = 'proto.ClientServer.PvpGamesBackgammonRollResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesBackgammonMoveRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesBackgammonMoveRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesBackgammonMoveRequest.displayName = 'proto.ClientServer.PvpGamesBackgammonMoveRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGamesBackgammonMoveResponse.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGamesBackgammonMoveResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesBackgammonMoveResponse.displayName = 'proto.ClientServer.PvpGamesBackgammonMoveResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.displayName = 'proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.displayName = 'proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesStateNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesStateNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesStateNotification.displayName = 'proto.ClientServer.PvpGamesStateNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesDecisionWaitNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ClientServer.PvpGamesDecisionWaitNotification.oneofGroups_);
};
goog.inherits(proto.ClientServer.PvpGamesDecisionWaitNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesDecisionWaitNotification.displayName = 'proto.ClientServer.PvpGamesDecisionWaitNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.displayName = 'proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.displayName = 'proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.displayName = 'proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.displayName = 'proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesDecisionMadeNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ClientServer.PvpGamesDecisionMadeNotification.oneofGroups_);
};
goog.inherits(proto.ClientServer.PvpGamesDecisionMadeNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesDecisionMadeNotification.displayName = 'proto.ClientServer.PvpGamesDecisionMadeNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.displayName = 'proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.displayName = 'proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.repeatedFields_, null);
};
goog.inherits(proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.displayName = 'proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.displayName = 'proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesWinNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ClientServer.PvpGamesWinNotification.oneofGroups_);
};
goog.inherits(proto.ClientServer.PvpGamesWinNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesWinNotification.displayName = 'proto.ClientServer.PvpGamesWinNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.displayName = 'proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesKickoutNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesKickoutNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesKickoutNotification.displayName = 'proto.ClientServer.PvpGamesKickoutNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesRoomTerminatedNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesRoomTerminatedNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesRoomTerminatedNotification.displayName = 'proto.ClientServer.PvpGamesRoomTerminatedNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesPlayerJoinNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesPlayerJoinNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesPlayerJoinNotification.displayName = 'proto.ClientServer.PvpGamesPlayerJoinNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesInvitationReceivedNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesInvitationReceivedNotification.displayName = 'proto.ClientServer.PvpGamesInvitationReceivedNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesInvitationResponseNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PvpGamesInvitationResponseNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesInvitationResponseNotification.displayName = 'proto.ClientServer.PvpGamesInvitationResponseNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PvpGamesRoomNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ClientServer.PvpGamesRoomNotification.oneofGroups_);
};
goog.inherits(proto.ClientServer.PvpGamesRoomNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PvpGamesRoomNotification.displayName = 'proto.ClientServer.PvpGamesRoomNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PlayerBalanceChangeNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PlayerBalanceChangeNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PlayerBalanceChangeNotification.displayName = 'proto.ClientServer.PlayerBalanceChangeNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.UserDisconnectNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.UserDisconnectNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.UserDisconnectNotification.displayName = 'proto.ClientServer.UserDisconnectNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.GameCommandRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ClientServer.GameCommandRequest.oneofGroups_);
};
goog.inherits(proto.ClientServer.GameCommandRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.GameCommandRequest.displayName = 'proto.ClientServer.GameCommandRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PingRequest.displayName = 'proto.ClientServer.PingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.PingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.PingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.PingResponse.displayName = 'proto.ClientServer.PingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.SetPlayerPrefsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.SetPlayerPrefsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.SetPlayerPrefsRequest.displayName = 'proto.ClientServer.SetPlayerPrefsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.SetPlayerPrefsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.SetPlayerPrefsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.SetPlayerPrefsResponse.displayName = 'proto.ClientServer.SetPlayerPrefsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.GameCommandResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ClientServer.GameCommandResponse.oneofGroups_);
};
goog.inherits(proto.ClientServer.GameCommandResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.GameCommandResponse.displayName = 'proto.ClientServer.GameCommandResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ClientServer.Request.oneofGroups_);
};
goog.inherits(proto.ClientServer.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.Request.displayName = 'proto.ClientServer.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.Error = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ClientServer.Error, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.Error.displayName = 'proto.ClientServer.Error';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.Notification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ClientServer.Notification.oneofGroups_);
};
goog.inherits(proto.ClientServer.Notification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.Notification.displayName = 'proto.ClientServer.Notification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ClientServer.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.ClientServer.Response.oneofGroups_);
};
goog.inherits(proto.ClientServer.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ClientServer.Response.displayName = 'proto.ClientServer.Response';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.SessionLoginRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.SessionLoginRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.SessionLoginRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.SessionLoginRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.SessionLoginRequest}
 */
proto.ClientServer.SessionLoginRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.SessionLoginRequest;
  return proto.ClientServer.SessionLoginRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.SessionLoginRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.SessionLoginRequest}
 */
proto.ClientServer.SessionLoginRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.SessionLoginRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.SessionLoginRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.SessionLoginRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.SessionLoginRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.ClientServer.SessionLoginRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.SessionLoginRequest} returns this
 */
proto.ClientServer.SessionLoginRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.SessionLoginRequest2.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.SessionLoginRequest2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.SessionLoginRequest2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.SessionLoginRequest2.toObject = function(includeInstance, msg) {
  var f, obj = {
    sid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    key1: jspb.Message.getFieldWithDefault(msg, 2, 0),
    key2: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.SessionLoginRequest2}
 */
proto.ClientServer.SessionLoginRequest2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.SessionLoginRequest2;
  return proto.ClientServer.SessionLoginRequest2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.SessionLoginRequest2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.SessionLoginRequest2}
 */
proto.ClientServer.SessionLoginRequest2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKey1(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setKey2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.SessionLoginRequest2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.SessionLoginRequest2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.SessionLoginRequest2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.SessionLoginRequest2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getKey1();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getKey2();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int64 sid = 1;
 * @return {number}
 */
proto.ClientServer.SessionLoginRequest2.prototype.getSid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.SessionLoginRequest2} returns this
 */
proto.ClientServer.SessionLoginRequest2.prototype.setSid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 key1 = 2;
 * @return {number}
 */
proto.ClientServer.SessionLoginRequest2.prototype.getKey1 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.SessionLoginRequest2} returns this
 */
proto.ClientServer.SessionLoginRequest2.prototype.setKey1 = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 key2 = 3;
 * @return {number}
 */
proto.ClientServer.SessionLoginRequest2.prototype.getKey2 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.SessionLoginRequest2} returns this
 */
proto.ClientServer.SessionLoginRequest2.prototype.setKey2 = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.SessionLoginResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.SessionLoginResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.SessionLoginResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.SessionLoginResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    uid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    time: jspb.Message.getFieldWithDefault(msg, 3, 0),
    hallId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    avatar: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.SessionLoginResponse}
 */
proto.ClientServer.SessionLoginResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.SessionLoginResponse;
  return proto.ClientServer.SessionLoginResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.SessionLoginResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.SessionLoginResponse}
 */
proto.ClientServer.SessionLoginResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHallId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatar(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.SessionLoginResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.SessionLoginResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.SessionLoginResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.SessionLoginResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getHallId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAvatar();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 uid = 1;
 * @return {number}
 */
proto.ClientServer.SessionLoginResponse.prototype.getUid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.SessionLoginResponse} returns this
 */
proto.ClientServer.SessionLoginResponse.prototype.setUid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 sid = 2;
 * @return {number}
 */
proto.ClientServer.SessionLoginResponse.prototype.getSid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.SessionLoginResponse} returns this
 */
proto.ClientServer.SessionLoginResponse.prototype.setSid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 time = 3;
 * @return {number}
 */
proto.ClientServer.SessionLoginResponse.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.SessionLoginResponse} returns this
 */
proto.ClientServer.SessionLoginResponse.prototype.setTime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 hall_id = 4;
 * @return {number}
 */
proto.ClientServer.SessionLoginResponse.prototype.getHallId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.SessionLoginResponse} returns this
 */
proto.ClientServer.SessionLoginResponse.prototype.setHallId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.ClientServer.SessionLoginResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.SessionLoginResponse} returns this
 */
proto.ClientServer.SessionLoginResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string avatar = 6;
 * @return {string}
 */
proto.ClientServer.SessionLoginResponse.prototype.getAvatar = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.SessionLoginResponse} returns this
 */
proto.ClientServer.SessionLoginResponse.prototype.setAvatar = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PlayerBalanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PlayerBalanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PlayerBalanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PlayerBalanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PlayerBalanceRequest}
 */
proto.ClientServer.PlayerBalanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PlayerBalanceRequest;
  return proto.ClientServer.PlayerBalanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PlayerBalanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PlayerBalanceRequest}
 */
proto.ClientServer.PlayerBalanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PlayerBalanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PlayerBalanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PlayerBalanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PlayerBalanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PlayerBalanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PlayerBalanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PlayerBalanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PlayerBalanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    balanceCents: jspb.Message.getFieldWithDefault(msg, 1, 0),
    coinValue: jspb.Message.getFieldWithDefault(msg, 2, 0),
    balanceCoins: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PlayerBalanceResponse}
 */
proto.ClientServer.PlayerBalanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PlayerBalanceResponse;
  return proto.ClientServer.PlayerBalanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PlayerBalanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PlayerBalanceResponse}
 */
proto.ClientServer.PlayerBalanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBalanceCents(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCoinValue(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBalanceCoins(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PlayerBalanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PlayerBalanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PlayerBalanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PlayerBalanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBalanceCents();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCoinValue();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBalanceCoins();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 balance_cents = 1;
 * @return {number}
 */
proto.ClientServer.PlayerBalanceResponse.prototype.getBalanceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PlayerBalanceResponse} returns this
 */
proto.ClientServer.PlayerBalanceResponse.prototype.setBalanceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 coin_value = 2;
 * @return {number}
 */
proto.ClientServer.PlayerBalanceResponse.prototype.getCoinValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PlayerBalanceResponse} returns this
 */
proto.ClientServer.PlayerBalanceResponse.prototype.setCoinValue = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 balance_coins = 3;
 * @return {number}
 */
proto.ClientServer.PlayerBalanceResponse.prototype.getBalanceCoins = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PlayerBalanceResponse} returns this
 */
proto.ClientServer.PlayerBalanceResponse.prototype.setBalanceCoins = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.GameSubscribeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.GameSubscribeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.GameSubscribeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.GameSubscribeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    gameId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.GameSubscribeRequest}
 */
proto.ClientServer.GameSubscribeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.GameSubscribeRequest;
  return proto.ClientServer.GameSubscribeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.GameSubscribeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.GameSubscribeRequest}
 */
proto.ClientServer.GameSubscribeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGameId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.GameSubscribeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.GameSubscribeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.GameSubscribeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.GameSubscribeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 game_id = 1;
 * @return {number}
 */
proto.ClientServer.GameSubscribeRequest.prototype.getGameId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.GameSubscribeRequest} returns this
 */
proto.ClientServer.GameSubscribeRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ClientServer.PvpGameRoom.oneofGroups_ = [[8,9]];

/**
 * @enum {number}
 */
proto.ClientServer.PvpGameRoom.RoomCase = {
  ROOM_NOT_SET: 0,
  POKER_ROOM: 8,
  BACKGAMMON_ROOM: 9
};

/**
 * @return {proto.ClientServer.PvpGameRoom.RoomCase}
 */
proto.ClientServer.PvpGameRoom.prototype.getRoomCase = function() {
  return /** @type {proto.ClientServer.PvpGameRoom.RoomCase} */(jspb.Message.computeOneofCase(this, proto.ClientServer.PvpGameRoom.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGameRoom.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGameRoom.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGameRoom} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameRoom.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    hallId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    maxPlayers: jspb.Message.getFieldWithDefault(msg, 5, 0),
    requiredBalance: jspb.Message.getFieldWithDefault(msg, 6, 0),
    showUid: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    pokerRoom: (f = msg.getPokerRoom()) && proto.ClientServer.PvpGameRoom.PokerRoom.toObject(includeInstance, f),
    backgammonRoom: (f = msg.getBackgammonRoom()) && proto.ClientServer.PvpGameRoom.BackgammonRoom.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGameRoom}
 */
proto.ClientServer.PvpGameRoom.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGameRoom;
  return proto.ClientServer.PvpGameRoom.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGameRoom} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGameRoom}
 */
proto.ClientServer.PvpGameRoom.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ClientServer.PvpGameRoom.RoomType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHallId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxPlayers(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequiredBalance(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowUid(value);
      break;
    case 8:
      var value = new proto.ClientServer.PvpGameRoom.PokerRoom;
      reader.readMessage(value,proto.ClientServer.PvpGameRoom.PokerRoom.deserializeBinaryFromReader);
      msg.setPokerRoom(value);
      break;
    case 9:
      var value = new proto.ClientServer.PvpGameRoom.BackgammonRoom;
      reader.readMessage(value,proto.ClientServer.PvpGameRoom.BackgammonRoom.deserializeBinaryFromReader);
      msg.setBackgammonRoom(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGameRoom.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGameRoom.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGameRoom} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameRoom.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHallId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMaxPlayers();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getRequiredBalance();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getShowUid();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getPokerRoom();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ClientServer.PvpGameRoom.PokerRoom.serializeBinaryToWriter
    );
  }
  f = message.getBackgammonRoom();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ClientServer.PvpGameRoom.BackgammonRoom.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.ClientServer.PvpGameRoom.RoomType = {
  POKER: 0,
  BACKGAMMON: 1
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGameRoom.PokerRoom.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGameRoom.PokerRoom.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameRoom.PokerRoom.toObject = function(includeInstance, msg) {
  var f, obj = {
    smallBlind: jspb.Message.getFieldWithDefault(msg, 1, 0),
    bigBlind: jspb.Message.getFieldWithDefault(msg, 2, 0),
    state: jspb.Message.getFieldWithDefault(msg, 3, 0),
    stateTimeLeft: jspb.Message.getFieldWithDefault(msg, 4, 0),
    playersList: jspb.Message.toObjectList(msg.getPlayersList(),
    proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.toObject, includeInstance),
    pendingPlayersList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    communityCards: msg.getCommunityCards_asB64(),
    pot: jspb.Message.getFieldWithDefault(msg, 8, 0),
    waitPlayersTime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    decisionTime: jspb.Message.getFieldWithDefault(msg, 10, 0),
    buttonRule: jspb.Message.getFieldWithDefault(msg, 11, 0),
    bettingRule: jspb.Message.getFieldWithDefault(msg, 12, 0),
    showPlayersBalance: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGameRoom.PokerRoom;
  return proto.ClientServer.PvpGameRoom.PokerRoom.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSmallBlind(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBigBlind(value);
      break;
    case 3:
      var value = /** @type {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStateTimeLeft(value);
      break;
    case 5:
      var value = new proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer;
      reader.readMessage(value,proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.deserializeBinaryFromReader);
      msg.addPlayers(value);
      break;
    case 6:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setPendingPlayersList(value);
      break;
    case 7:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCommunityCards(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPot(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWaitPlayersTime(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDecisionTime(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setButtonRule(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBettingRule(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowPlayersBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGameRoom.PokerRoom.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameRoom.PokerRoom.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSmallBlind();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBigBlind();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStateTimeLeft();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPlayersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.serializeBinaryToWriter
    );
  }
  f = message.getPendingPlayersList();
  if (f.length > 0) {
    writer.writePackedInt32(
      6,
      f
    );
  }
  f = message.getCommunityCards_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      7,
      f
    );
  }
  f = message.getPot();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getWaitPlayersTime();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getDecisionTime();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getButtonRule();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getBettingRule();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getShowPlayersBalance();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerState = {
  STATE_IDLE: 0,
  STATE_PREFLOP: 1,
  STATE_FLOP: 2,
  STATE_TURN: 3,
  STATE_RIVER: 4,
  STATE_SHOWDOWN: 5
};

/**
 * @enum {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction = {
  NO_ACTION: 0,
  CHECK: 1,
  RAISE: 2,
  CALL: 3,
  FOLD: 4,
  ALL_IN: 5
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    cards: msg.getCards_asB64(),
    button: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    combination: jspb.Message.getFieldWithDefault(msg, 5, 0),
    combinationName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    isActive: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    isWinner: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    smallBlind: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    bigBlind: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    seatNumber: jspb.Message.getFieldWithDefault(msg, 11, 0),
    lastAction: jspb.Message.getFieldWithDefault(msg, 12, 0),
    liveBet: jspb.Message.getFieldWithDefault(msg, 13, 0),
    roundBet: jspb.Message.getFieldWithDefault(msg, 14, 0),
    win: jspb.Message.getFieldWithDefault(msg, 15, 0),
    avatar: jspb.Message.getFieldWithDefault(msg, 16, ""),
    balance: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer;
  return proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCards(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setButton(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCombination(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCombinationName(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsActive(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsWinner(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSmallBlind(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBigBlind(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeatNumber(value);
      break;
    case 12:
      var value = /** @type {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} */ (reader.readEnum());
      msg.setLastAction(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLiveBet(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoundBet(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWin(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatar(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCards_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getButton();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getCombination();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getCombinationName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsActive();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getIsWinner();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getSmallBlind();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getBigBlind();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getSeatNumber();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getLastAction();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getLiveBet();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getRoundBet();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getWin();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getAvatar();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getBalance();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string user_name = 2;
 * @return {string}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes cards = 3;
 * @return {!(string|Uint8Array)}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getCards = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes cards = 3;
 * This is a type-conversion wrapper around `getCards()`
 * @return {string}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getCards_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCards()));
};


/**
 * optional bytes cards = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCards()`
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getCards_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCards()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setCards = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional bool button = 4;
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getButton = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setButton = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int32 combination = 5;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getCombination = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setCombination = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string combination_name = 6;
 * @return {string}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getCombinationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setCombinationName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool is_active = 7;
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getIsActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setIsActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool is_winner = 8;
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getIsWinner = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setIsWinner = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool small_blind = 9;
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getSmallBlind = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setSmallBlind = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool big_blind = 10;
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getBigBlind = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setBigBlind = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional int32 seat_number = 11;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getSeatNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setSeatNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional PokerAction last_action = 12;
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getLastAction = function() {
  return /** @type {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setLastAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional int32 live_bet = 13;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getLiveBet = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setLiveBet = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 round_bet = 14;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getRoundBet = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setRoundBet = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 win = 15;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getWin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setWin = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string avatar = 16;
 * @return {string}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getAvatar = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setAvatar = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int32 balance = 17;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer.prototype.setBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int32 small_blind = 1;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getSmallBlind = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setSmallBlind = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 big_blind = 2;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getBigBlind = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setBigBlind = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional PokerState state = 3;
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerState}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getState = function() {
  return /** @type {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerState} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerState} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 state_time_left = 4;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getStateTimeLeft = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setStateTimeLeft = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated PokerPlayer players = 5;
 * @return {!Array<!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer>}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getPlayersList = function() {
  return /** @type{!Array<!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer, 5));
};


/**
 * @param {!Array<!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer>} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
*/
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setPlayersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.addPlayers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.ClientServer.PvpGameRoom.PokerRoom.PokerPlayer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.clearPlayersList = function() {
  return this.setPlayersList([]);
};


/**
 * repeated int32 pending_players = 6;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getPendingPlayersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setPendingPlayersList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.addPendingPlayers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.clearPendingPlayersList = function() {
  return this.setPendingPlayersList([]);
};


/**
 * optional bytes community_cards = 7;
 * @return {!(string|Uint8Array)}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getCommunityCards = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * optional bytes community_cards = 7;
 * This is a type-conversion wrapper around `getCommunityCards()`
 * @return {string}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getCommunityCards_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCommunityCards()));
};


/**
 * optional bytes community_cards = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCommunityCards()`
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getCommunityCards_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCommunityCards()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setCommunityCards = function(value) {
  return jspb.Message.setProto3BytesField(this, 7, value);
};


/**
 * optional int32 pot = 8;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getPot = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setPot = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 wait_players_time = 9;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getWaitPlayersTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setWaitPlayersTime = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 decision_time = 10;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getDecisionTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setDecisionTime = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 button_rule = 11;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getButtonRule = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setButtonRule = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 betting_rule = 12;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getBettingRule = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setBettingRule = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional bool show_players_balance = 13;
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.getShowPlayersBalance = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom} returns this
 */
proto.ClientServer.PvpGameRoom.PokerRoom.prototype.setShowPlayersBalance = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.repeatedFields_ = [5,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGameRoom.BackgammonRoom.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGameRoom.BackgammonRoom} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    maxTables: jspb.Message.getFieldWithDefault(msg, 2, 0),
    maxMultiplier: jspb.Message.getFieldWithDefault(msg, 3, 0),
    betPerScore: jspb.Message.getFieldWithDefault(msg, 4, 0),
    tablesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    currentTable: (f = msg.getCurrentTable()) && proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.toObject(includeInstance, f),
    pendingPlayersList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    decisionTime: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGameRoom.BackgammonRoom;
  return proto.ClientServer.PvpGameRoom.BackgammonRoom.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGameRoom.BackgammonRoom} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxTables(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxMultiplier(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBetPerScore(value);
      break;
    case 5:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setTablesList(value);
      break;
    case 6:
      var value = new proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable;
      reader.readMessage(value,proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.deserializeBinaryFromReader);
      msg.setCurrentTable(value);
      break;
    case 7:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setPendingPlayersList(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDecisionTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGameRoom.BackgammonRoom.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGameRoom.BackgammonRoom} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMaxTables();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMaxMultiplier();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBetPerScore();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTablesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      5,
      f
    );
  }
  f = message.getCurrentTable();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.serializeBinaryToWriter
    );
  }
  f = message.getPendingPlayersList();
  if (f.length > 0) {
    writer.writePackedInt32(
      7,
      f
    );
  }
  f = message.getDecisionTime();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonState = {
  STATE_IDLE: 0,
  STATE_BALLOT: 1,
  STATE_GAME: 2,
  STATE_SHOWDOWN: 3
};

/**
 * @enum {number}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonAction = {
  ROLL: 0,
  MOVE: 1,
  DOUBLE: 2
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.repeatedFields_ = [5,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.toObject = function(includeInstance, msg) {
  var f, obj = {
    valid: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    userId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    userName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    numbersList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    score: jspb.Message.getFieldWithDefault(msg, 6, 0),
    initialNumbersList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    canDouble: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer;
  return proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 5:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setNumbersList(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScore(value);
      break;
    case 7:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setInitialNumbersList(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanDouble(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValid();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNumbersList();
  if (f.length > 0) {
    writer.writePackedInt32(
      5,
      f
    );
  }
  f = message.getScore();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getInitialNumbersList();
  if (f.length > 0) {
    writer.writePackedInt32(
      7,
      f
    );
  }
  f = message.getCanDouble();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional bool valid = 1;
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.getValid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.setValid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool active = 2;
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional int32 user_id = 3;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string user_name = 4;
 * @return {string}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated int32 numbers = 5;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.getNumbersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.setNumbersList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.addNumbers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.clearNumbersList = function() {
  return this.setNumbersList([]);
};


/**
 * optional int32 score = 6;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.setScore = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated int32 initial_numbers = 7;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.getInitialNumbersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.setInitialNumbersList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.addInitialNumbers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.clearInitialNumbersList = function() {
  return this.setInitialNumbersList([]);
};


/**
 * optional bool can_double = 8;
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.getCanDouble = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.prototype.setCanDouble = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.toObject = function(includeInstance, msg) {
  var f, obj = {
    tableId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    playersList: jspb.Message.toObjectList(msg.getPlayersList(),
    proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.toObject, includeInstance),
    chipsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    state: jspb.Message.getFieldWithDefault(msg, 4, 0),
    multiplier: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable;
  return proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTableId(value);
      break;
    case 2:
      var value = new proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer;
      reader.readMessage(value,proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.deserializeBinaryFromReader);
      msg.addPlayers(value);
      break;
    case 3:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setChipsList(value);
      break;
    case 4:
      var value = /** @type {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMultiplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTableId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPlayersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer.serializeBinaryToWriter
    );
  }
  f = message.getChipsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getMultiplier();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 table_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.getTableId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.setTableId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated BackgammonPlayer players = 2;
 * @return {!Array<!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer>}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.getPlayersList = function() {
  return /** @type{!Array<!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer, 2));
};


/**
 * @param {!Array<!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer>} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable} returns this
*/
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.setPlayersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.addPlayers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonPlayer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.clearPlayersList = function() {
  return this.setPlayersList([]);
};


/**
 * repeated int32 chips = 3;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.getChipsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.setChipsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.addChips = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.clearChipsList = function() {
  return this.setChipsList([]);
};


/**
 * optional BackgammonState state = 4;
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonState}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.getState = function() {
  return /** @type {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonState} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonState} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int32 multiplier = 5;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.getMultiplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable.prototype.setMultiplier = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 max_tables = 2;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.getMaxTables = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.setMaxTables = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 max_multiplier = 3;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.getMaxMultiplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.setMaxMultiplier = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 bet_per_score = 4;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.getBetPerScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.setBetPerScore = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated int32 tables = 5;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.getTablesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.setTablesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.addTables = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.clearTablesList = function() {
  return this.setTablesList([]);
};


/**
 * optional BackgammonTable current_table = 6;
 * @return {?proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.getCurrentTable = function() {
  return /** @type{?proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable, 6));
};


/**
 * @param {?proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonTable|undefined} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
*/
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.setCurrentTable = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.clearCurrentTable = function() {
  return this.setCurrentTable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.hasCurrentTable = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated int32 pending_players = 7;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.getPendingPlayersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.setPendingPlayersList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.addPendingPlayers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.clearPendingPlayersList = function() {
  return this.setPendingPlayersList([]);
};


/**
 * optional int32 decision_time = 8;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.getDecisionTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom.BackgammonRoom} returns this
 */
proto.ClientServer.PvpGameRoom.BackgammonRoom.prototype.setDecisionTime = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional RoomType type = 1;
 * @return {!proto.ClientServer.PvpGameRoom.RoomType}
 */
proto.ClientServer.PvpGameRoom.prototype.getType = function() {
  return /** @type {!proto.ClientServer.PvpGameRoom.RoomType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ClientServer.PvpGameRoom.RoomType} value
 * @return {!proto.ClientServer.PvpGameRoom} returns this
 */
proto.ClientServer.PvpGameRoom.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 id = 2;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom} returns this
 */
proto.ClientServer.PvpGameRoom.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.ClientServer.PvpGameRoom.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGameRoom} returns this
 */
proto.ClientServer.PvpGameRoom.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 hall_id = 4;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.prototype.getHallId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom} returns this
 */
proto.ClientServer.PvpGameRoom.prototype.setHallId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 max_players = 5;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.prototype.getMaxPlayers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom} returns this
 */
proto.ClientServer.PvpGameRoom.prototype.setMaxPlayers = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 required_balance = 6;
 * @return {number}
 */
proto.ClientServer.PvpGameRoom.prototype.getRequiredBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGameRoom} returns this
 */
proto.ClientServer.PvpGameRoom.prototype.setRequiredBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool show_uid = 7;
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.prototype.getShowUid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGameRoom} returns this
 */
proto.ClientServer.PvpGameRoom.prototype.setShowUid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional PokerRoom poker_room = 8;
 * @return {?proto.ClientServer.PvpGameRoom.PokerRoom}
 */
proto.ClientServer.PvpGameRoom.prototype.getPokerRoom = function() {
  return /** @type{?proto.ClientServer.PvpGameRoom.PokerRoom} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGameRoom.PokerRoom, 8));
};


/**
 * @param {?proto.ClientServer.PvpGameRoom.PokerRoom|undefined} value
 * @return {!proto.ClientServer.PvpGameRoom} returns this
*/
proto.ClientServer.PvpGameRoom.prototype.setPokerRoom = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.ClientServer.PvpGameRoom.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGameRoom} returns this
 */
proto.ClientServer.PvpGameRoom.prototype.clearPokerRoom = function() {
  return this.setPokerRoom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.prototype.hasPokerRoom = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional BackgammonRoom backgammon_room = 9;
 * @return {?proto.ClientServer.PvpGameRoom.BackgammonRoom}
 */
proto.ClientServer.PvpGameRoom.prototype.getBackgammonRoom = function() {
  return /** @type{?proto.ClientServer.PvpGameRoom.BackgammonRoom} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGameRoom.BackgammonRoom, 9));
};


/**
 * @param {?proto.ClientServer.PvpGameRoom.BackgammonRoom|undefined} value
 * @return {!proto.ClientServer.PvpGameRoom} returns this
*/
proto.ClientServer.PvpGameRoom.prototype.setBackgammonRoom = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.ClientServer.PvpGameRoom.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGameRoom} returns this
 */
proto.ClientServer.PvpGameRoom.prototype.clearBackgammonRoom = function() {
  return this.setBackgammonRoom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGameRoom.prototype.hasBackgammonRoom = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGameSubscribeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGameSubscribeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGameSubscribeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameSubscribeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGameSubscribeResponse}
 */
proto.ClientServer.PvpGameSubscribeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGameSubscribeResponse;
  return proto.ClientServer.PvpGameSubscribeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGameSubscribeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGameSubscribeResponse}
 */
proto.ClientServer.PvpGameSubscribeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGameSubscribeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGameSubscribeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGameSubscribeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGameSubscribeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ClientServer.GameSubscribeResponse.oneofGroups_ = [[2]];

/**
 * @enum {number}
 */
proto.ClientServer.GameSubscribeResponse.SubscribeCase = {
  SUBSCRIBE_NOT_SET: 0,
  PVP_GAME_SUBSCRIBE_RESPONSE: 2
};

/**
 * @return {proto.ClientServer.GameSubscribeResponse.SubscribeCase}
 */
proto.ClientServer.GameSubscribeResponse.prototype.getSubscribeCase = function() {
  return /** @type {proto.ClientServer.GameSubscribeResponse.SubscribeCase} */(jspb.Message.computeOneofCase(this, proto.ClientServer.GameSubscribeResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.GameSubscribeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.GameSubscribeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.GameSubscribeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.GameSubscribeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    gameId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pvpGameSubscribeResponse: (f = msg.getPvpGameSubscribeResponse()) && proto.ClientServer.PvpGameSubscribeResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.GameSubscribeResponse}
 */
proto.ClientServer.GameSubscribeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.GameSubscribeResponse;
  return proto.ClientServer.GameSubscribeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.GameSubscribeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.GameSubscribeResponse}
 */
proto.ClientServer.GameSubscribeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGameId(value);
      break;
    case 2:
      var value = new proto.ClientServer.PvpGameSubscribeResponse;
      reader.readMessage(value,proto.ClientServer.PvpGameSubscribeResponse.deserializeBinaryFromReader);
      msg.setPvpGameSubscribeResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.GameSubscribeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.GameSubscribeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.GameSubscribeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.GameSubscribeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPvpGameSubscribeResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ClientServer.PvpGameSubscribeResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 game_id = 1;
 * @return {number}
 */
proto.ClientServer.GameSubscribeResponse.prototype.getGameId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.GameSubscribeResponse} returns this
 */
proto.ClientServer.GameSubscribeResponse.prototype.setGameId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional PvpGameSubscribeResponse pvp_game_subscribe_response = 2;
 * @return {?proto.ClientServer.PvpGameSubscribeResponse}
 */
proto.ClientServer.GameSubscribeResponse.prototype.getPvpGameSubscribeResponse = function() {
  return /** @type{?proto.ClientServer.PvpGameSubscribeResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGameSubscribeResponse, 2));
};


/**
 * @param {?proto.ClientServer.PvpGameSubscribeResponse|undefined} value
 * @return {!proto.ClientServer.GameSubscribeResponse} returns this
*/
proto.ClientServer.GameSubscribeResponse.prototype.setPvpGameSubscribeResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.ClientServer.GameSubscribeResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameSubscribeResponse} returns this
 */
proto.ClientServer.GameSubscribeResponse.prototype.clearPvpGameSubscribeResponse = function() {
  return this.setPvpGameSubscribeResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameSubscribeResponse.prototype.hasPvpGameSubscribeResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesListUsersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesListUsersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesListUsersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListUsersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    limit: jspb.Message.getFieldWithDefault(msg, 1, 0),
    roomId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesListUsersRequest}
 */
proto.ClientServer.PvpGamesListUsersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesListUsersRequest;
  return proto.ClientServer.PvpGamesListUsersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesListUsersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesListUsersRequest}
 */
proto.ClientServer.PvpGamesListUsersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoomId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesListUsersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesListUsersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesListUsersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListUsersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRoomId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 limit = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesListUsersRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesListUsersRequest} returns this
 */
proto.ClientServer.PvpGamesListUsersRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 room_id = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesListUsersRequest.prototype.getRoomId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesListUsersRequest} returns this
 */
proto.ClientServer.PvpGamesListUsersRequest.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGamesListUsersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesListUsersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesListUsersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesListUsersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListUsersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    usersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesListUsersResponse}
 */
proto.ClientServer.PvpGamesListUsersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesListUsersResponse;
  return proto.ClientServer.PvpGamesListUsersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesListUsersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesListUsersResponse}
 */
proto.ClientServer.PvpGamesListUsersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setUsersList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesListUsersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesListUsersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesListUsersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListUsersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 users = 1;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGamesListUsersResponse.prototype.getUsersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGamesListUsersResponse} returns this
 */
proto.ClientServer.PvpGamesListUsersResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGamesListUsersResponse} returns this
 */
proto.ClientServer.PvpGamesListUsersResponse.prototype.addUsers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesListUsersResponse} returns this
 */
proto.ClientServer.PvpGamesListUsersResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesInviteOpponentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesInviteOpponentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesInviteOpponentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesInviteOpponentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    gameId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    roomId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesInviteOpponentRequest}
 */
proto.ClientServer.PvpGamesInviteOpponentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesInviteOpponentRequest;
  return proto.ClientServer.PvpGamesInviteOpponentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesInviteOpponentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesInviteOpponentRequest}
 */
proto.ClientServer.PvpGamesInviteOpponentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGameId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoomId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesInviteOpponentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesInviteOpponentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesInviteOpponentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesInviteOpponentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getGameId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRoomId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesInviteOpponentRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesInviteOpponentRequest} returns this
 */
proto.ClientServer.PvpGamesInviteOpponentRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 game_id = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesInviteOpponentRequest.prototype.getGameId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesInviteOpponentRequest} returns this
 */
proto.ClientServer.PvpGamesInviteOpponentRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 room_id = 3;
 * @return {number}
 */
proto.ClientServer.PvpGamesInviteOpponentRequest.prototype.getRoomId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesInviteOpponentRequest} returns this
 */
proto.ClientServer.PvpGamesInviteOpponentRequest.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesInviteOpponentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesInviteOpponentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesInviteOpponentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesInviteOpponentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesInviteOpponentResponse}
 */
proto.ClientServer.PvpGamesInviteOpponentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesInviteOpponentResponse;
  return proto.ClientServer.PvpGamesInviteOpponentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesInviteOpponentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesInviteOpponentResponse}
 */
proto.ClientServer.PvpGamesInviteOpponentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesInviteOpponentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesInviteOpponentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesInviteOpponentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesInviteOpponentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string hash = 1;
 * @return {string}
 */
proto.ClientServer.PvpGamesInviteOpponentResponse.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGamesInviteOpponentResponse} returns this
 */
proto.ClientServer.PvpGamesInviteOpponentResponse.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesListTournamentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesListTournamentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesListTournamentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListTournamentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesListTournamentsRequest}
 */
proto.ClientServer.PvpGamesListTournamentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesListTournamentsRequest;
  return proto.ClientServer.PvpGamesListTournamentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesListTournamentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesListTournamentsRequest}
 */
proto.ClientServer.PvpGamesListTournamentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesListTournamentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesListTournamentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesListTournamentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListTournamentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGamesListTournamentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesListTournamentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesListTournamentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListTournamentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tournamentsList: jspb.Message.toObjectList(msg.getTournamentsList(),
    proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesListTournamentsResponse;
  return proto.ClientServer.PvpGamesListTournamentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesListTournamentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ClientServer.PvpGamesListTournamentsResponse.Tournament;
      reader.readMessage(value,proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.deserializeBinaryFromReader);
      msg.addTournaments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesListTournamentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesListTournamentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListTournamentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTournamentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.toObject = function(includeInstance, msg) {
  var f, obj = {
    tournamentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    roomId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    maxPlayers: jspb.Message.getFieldWithDefault(msg, 3, 0),
    prize: jspb.Message.getFieldWithDefault(msg, 4, 0),
    active: jspb.Message.getFieldWithDefault(msg, 5, 0),
    level: jspb.Message.getFieldWithDefault(msg, 6, 0),
    pending: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesListTournamentsResponse.Tournament;
  return proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTournamentId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoomId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxPlayers(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrize(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActive(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLevel(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPending(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTournamentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRoomId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMaxPlayers();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPrize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getActive();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPending();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional int32 tournament_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.getTournamentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament} returns this
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.setTournamentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 room_id = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.getRoomId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament} returns this
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 max_players = 3;
 * @return {number}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.getMaxPlayers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament} returns this
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.setMaxPlayers = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 prize = 4;
 * @return {number}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.getPrize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament} returns this
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.setPrize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 active = 5;
 * @return {number}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.getActive = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament} returns this
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.setActive = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 level = 6;
 * @return {number}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament} returns this
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool pending = 7;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.getPending = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament} returns this
 */
proto.ClientServer.PvpGamesListTournamentsResponse.Tournament.prototype.setPending = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * repeated Tournament tournaments = 1;
 * @return {!Array<!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament>}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.prototype.getTournamentsList = function() {
  return /** @type{!Array<!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ClientServer.PvpGamesListTournamentsResponse.Tournament, 1));
};


/**
 * @param {!Array<!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament>} value
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse} returns this
*/
proto.ClientServer.PvpGamesListTournamentsResponse.prototype.setTournamentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse.Tournament}
 */
proto.ClientServer.PvpGamesListTournamentsResponse.prototype.addTournaments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ClientServer.PvpGamesListTournamentsResponse.Tournament, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesListTournamentsResponse} returns this
 */
proto.ClientServer.PvpGamesListTournamentsResponse.prototype.clearTournamentsList = function() {
  return this.setTournamentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesAcceptInvitationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesAcceptInvitationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesAcceptInvitationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesAcceptInvitationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accept: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesAcceptInvitationRequest}
 */
proto.ClientServer.PvpGamesAcceptInvitationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesAcceptInvitationRequest;
  return proto.ClientServer.PvpGamesAcceptInvitationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesAcceptInvitationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesAcceptInvitationRequest}
 */
proto.ClientServer.PvpGamesAcceptInvitationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccept(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesAcceptInvitationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesAcceptInvitationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesAcceptInvitationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesAcceptInvitationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccept();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string hash = 1;
 * @return {string}
 */
proto.ClientServer.PvpGamesAcceptInvitationRequest.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGamesAcceptInvitationRequest} returns this
 */
proto.ClientServer.PvpGamesAcceptInvitationRequest.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool accept = 2;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesAcceptInvitationRequest.prototype.getAccept = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesAcceptInvitationRequest} returns this
 */
proto.ClientServer.PvpGamesAcceptInvitationRequest.prototype.setAccept = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesAcceptInvitationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesAcceptInvitationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesAcceptInvitationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesAcceptInvitationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesAcceptInvitationResponse}
 */
proto.ClientServer.PvpGamesAcceptInvitationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesAcceptInvitationResponse;
  return proto.ClientServer.PvpGamesAcceptInvitationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesAcceptInvitationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesAcceptInvitationResponse}
 */
proto.ClientServer.PvpGamesAcceptInvitationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesAcceptInvitationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesAcceptInvitationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesAcceptInvitationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesAcceptInvitationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesAcceptInvitationResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesAcceptInvitationResponse} returns this
 */
proto.ClientServer.PvpGamesAcceptInvitationResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesListRoomsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesListRoomsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesListRoomsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListRoomsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesListRoomsRequest}
 */
proto.ClientServer.PvpGamesListRoomsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesListRoomsRequest;
  return proto.ClientServer.PvpGamesListRoomsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesListRoomsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesListRoomsRequest}
 */
proto.ClientServer.PvpGamesListRoomsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesListRoomsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesListRoomsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesListRoomsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListRoomsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGamesListRoomsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesListRoomsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesListRoomsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesListRoomsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListRoomsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomsList: jspb.Message.toObjectList(msg.getRoomsList(),
    proto.ClientServer.PvpGameRoom.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesListRoomsResponse}
 */
proto.ClientServer.PvpGamesListRoomsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesListRoomsResponse;
  return proto.ClientServer.PvpGamesListRoomsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesListRoomsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesListRoomsResponse}
 */
proto.ClientServer.PvpGamesListRoomsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ClientServer.PvpGameRoom;
      reader.readMessage(value,proto.ClientServer.PvpGameRoom.deserializeBinaryFromReader);
      msg.addRooms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesListRoomsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesListRoomsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesListRoomsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesListRoomsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ClientServer.PvpGameRoom.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PvpGameRoom rooms = 1;
 * @return {!Array<!proto.ClientServer.PvpGameRoom>}
 */
proto.ClientServer.PvpGamesListRoomsResponse.prototype.getRoomsList = function() {
  return /** @type{!Array<!proto.ClientServer.PvpGameRoom>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ClientServer.PvpGameRoom, 1));
};


/**
 * @param {!Array<!proto.ClientServer.PvpGameRoom>} value
 * @return {!proto.ClientServer.PvpGamesListRoomsResponse} returns this
*/
proto.ClientServer.PvpGamesListRoomsResponse.prototype.setRoomsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ClientServer.PvpGameRoom=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGameRoom}
 */
proto.ClientServer.PvpGamesListRoomsResponse.prototype.addRooms = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ClientServer.PvpGameRoom, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesListRoomsResponse} returns this
 */
proto.ClientServer.PvpGamesListRoomsResponse.prototype.clearRoomsList = function() {
  return this.setRoomsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesWatchRoomRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesWatchRoomRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesWatchRoomRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesWatchRoomRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tableId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesWatchRoomRequest}
 */
proto.ClientServer.PvpGamesWatchRoomRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesWatchRoomRequest;
  return proto.ClientServer.PvpGamesWatchRoomRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesWatchRoomRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesWatchRoomRequest}
 */
proto.ClientServer.PvpGamesWatchRoomRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoomId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTableId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesWatchRoomRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesWatchRoomRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesWatchRoomRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesWatchRoomRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTableId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 room_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesWatchRoomRequest.prototype.getRoomId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesWatchRoomRequest} returns this
 */
proto.ClientServer.PvpGamesWatchRoomRequest.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 table_id = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesWatchRoomRequest.prototype.getTableId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesWatchRoomRequest} returns this
 */
proto.ClientServer.PvpGamesWatchRoomRequest.prototype.setTableId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesWatchRoomResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesWatchRoomResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesWatchRoomResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    hallId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    maxPlayers: jspb.Message.getFieldWithDefault(msg, 5, 0),
    live: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    showUid: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesWatchRoomResponse}
 */
proto.ClientServer.PvpGamesWatchRoomResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesWatchRoomResponse;
  return proto.ClientServer.PvpGamesWatchRoomResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesWatchRoomResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesWatchRoomResponse}
 */
proto.ClientServer.PvpGamesWatchRoomResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ClientServer.PvpGameRoom.RoomType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHallId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxPlayers(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLive(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowUid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesWatchRoomResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesWatchRoomResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesWatchRoomResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHallId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMaxPlayers();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getLive();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getShowUid();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional PvpGameRoom.RoomType type = 1;
 * @return {!proto.ClientServer.PvpGameRoom.RoomType}
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.getType = function() {
  return /** @type {!proto.ClientServer.PvpGameRoom.RoomType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ClientServer.PvpGameRoom.RoomType} value
 * @return {!proto.ClientServer.PvpGamesWatchRoomResponse} returns this
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 id = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesWatchRoomResponse} returns this
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGamesWatchRoomResponse} returns this
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 hall_id = 4;
 * @return {number}
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.getHallId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesWatchRoomResponse} returns this
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.setHallId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 max_players = 5;
 * @return {number}
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.getMaxPlayers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesWatchRoomResponse} returns this
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.setMaxPlayers = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool live = 6;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.getLive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesWatchRoomResponse} returns this
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.setLive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool show_uid = 7;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.getShowUid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesWatchRoomResponse} returns this
 */
proto.ClientServer.PvpGamesWatchRoomResponse.prototype.setShowUid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesPlayRoomRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesPlayRoomRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesPlayRoomRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesPlayRoomRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    aiLevel: jspb.Message.getFieldWithDefault(msg, 2, 0),
    tournamentId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesPlayRoomRequest}
 */
proto.ClientServer.PvpGamesPlayRoomRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesPlayRoomRequest;
  return proto.ClientServer.PvpGamesPlayRoomRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesPlayRoomRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesPlayRoomRequest}
 */
proto.ClientServer.PvpGamesPlayRoomRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoomId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAiLevel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTournamentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesPlayRoomRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesPlayRoomRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesPlayRoomRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesPlayRoomRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAiLevel();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTournamentId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 room_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesPlayRoomRequest.prototype.getRoomId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesPlayRoomRequest} returns this
 */
proto.ClientServer.PvpGamesPlayRoomRequest.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 ai_level = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesPlayRoomRequest.prototype.getAiLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesPlayRoomRequest} returns this
 */
proto.ClientServer.PvpGamesPlayRoomRequest.prototype.setAiLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 tournament_id = 3;
 * @return {number}
 */
proto.ClientServer.PvpGamesPlayRoomRequest.prototype.getTournamentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesPlayRoomRequest} returns this
 */
proto.ClientServer.PvpGamesPlayRoomRequest.prototype.setTournamentId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesPlayRoomResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesPlayRoomResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesPlayRoomResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesPlayRoomResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    added: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    queuePosition: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesPlayRoomResponse}
 */
proto.ClientServer.PvpGamesPlayRoomResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesPlayRoomResponse;
  return proto.ClientServer.PvpGamesPlayRoomResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesPlayRoomResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesPlayRoomResponse}
 */
proto.ClientServer.PvpGamesPlayRoomResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdded(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQueuePosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesPlayRoomResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesPlayRoomResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesPlayRoomResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesPlayRoomResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdded();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getQueuePosition();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional bool added = 1;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesPlayRoomResponse.prototype.getAdded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesPlayRoomResponse} returns this
 */
proto.ClientServer.PvpGamesPlayRoomResponse.prototype.setAdded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int32 queue_position = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesPlayRoomResponse.prototype.getQueuePosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesPlayRoomResponse} returns this
 */
proto.ClientServer.PvpGamesPlayRoomResponse.prototype.setQueuePosition = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesExitRoomRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesExitRoomRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesExitRoomRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesExitRoomRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesExitRoomRequest}
 */
proto.ClientServer.PvpGamesExitRoomRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesExitRoomRequest;
  return proto.ClientServer.PvpGamesExitRoomRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesExitRoomRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesExitRoomRequest}
 */
proto.ClientServer.PvpGamesExitRoomRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesExitRoomRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesExitRoomRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesExitRoomRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesExitRoomRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesExitRoomResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesExitRoomResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesExitRoomResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesExitRoomResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesExitRoomResponse}
 */
proto.ClientServer.PvpGamesExitRoomResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesExitRoomResponse;
  return proto.ClientServer.PvpGamesExitRoomResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesExitRoomResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesExitRoomResponse}
 */
proto.ClientServer.PvpGamesExitRoomResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesExitRoomResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesExitRoomResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesExitRoomResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesExitRoomResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesPokerBetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesPokerBetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesPokerBetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesPokerBetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    betType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesPokerBetRequest}
 */
proto.ClientServer.PvpGamesPokerBetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesPokerBetRequest;
  return proto.ClientServer.PvpGamesPokerBetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesPokerBetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesPokerBetRequest}
 */
proto.ClientServer.PvpGamesPokerBetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} */ (reader.readEnum());
      msg.setBetType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesPokerBetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesPokerBetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesPokerBetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesPokerBetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBetType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional PvpGameRoom.PokerRoom.PokerAction bet_type = 1;
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction}
 */
proto.ClientServer.PvpGamesPokerBetRequest.prototype.getBetType = function() {
  return /** @type {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} value
 * @return {!proto.ClientServer.PvpGamesPokerBetRequest} returns this
 */
proto.ClientServer.PvpGamesPokerBetRequest.prototype.setBetType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesPokerBetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesPokerBetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesPokerBetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesPokerBetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    balance: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesPokerBetResponse}
 */
proto.ClientServer.PvpGamesPokerBetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesPokerBetResponse;
  return proto.ClientServer.PvpGamesPokerBetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesPokerBetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesPokerBetResponse}
 */
proto.ClientServer.PvpGamesPokerBetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesPokerBetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesPokerBetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesPokerBetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesPokerBetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getBalance();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesPokerBetResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesPokerBetResponse} returns this
 */
proto.ClientServer.PvpGamesPokerBetResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int32 balance = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesPokerBetResponse.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesPokerBetResponse} returns this
 */
proto.ClientServer.PvpGamesPokerBetResponse.prototype.setBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGamesBackgammonRollRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesBackgammonRollRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesBackgammonRollRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesBackgammonRollRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesBackgammonRollRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    choicesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesBackgammonRollRequest}
 */
proto.ClientServer.PvpGamesBackgammonRollRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesBackgammonRollRequest;
  return proto.ClientServer.PvpGamesBackgammonRollRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesBackgammonRollRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesBackgammonRollRequest}
 */
proto.ClientServer.PvpGamesBackgammonRollRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setChoicesList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesBackgammonRollRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesBackgammonRollRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesBackgammonRollRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesBackgammonRollRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChoicesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 choices = 1;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGamesBackgammonRollRequest.prototype.getChoicesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGamesBackgammonRollRequest} returns this
 */
proto.ClientServer.PvpGamesBackgammonRollRequest.prototype.setChoicesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGamesBackgammonRollRequest} returns this
 */
proto.ClientServer.PvpGamesBackgammonRollRequest.prototype.addChoices = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesBackgammonRollRequest} returns this
 */
proto.ClientServer.PvpGamesBackgammonRollRequest.prototype.clearChoicesList = function() {
  return this.setChoicesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesBackgammonRollResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesBackgammonRollResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    numbersList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    seed: jspb.Message.getFieldWithDefault(msg, 3, ""),
    salt: jspb.Message.getFieldWithDefault(msg, 4, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesBackgammonRollResponse}
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesBackgammonRollResponse;
  return proto.ClientServer.PvpGamesBackgammonRollResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesBackgammonRollResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesBackgammonRollResponse}
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setNumbersList(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeed(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSalt(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesBackgammonRollResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesBackgammonRollResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getNumbersList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getSeed();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSalt();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesBackgammonRollResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated int32 numbers = 2;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.getNumbersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGamesBackgammonRollResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.setNumbersList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGamesBackgammonRollResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.addNumbers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesBackgammonRollResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.clearNumbersList = function() {
  return this.setNumbersList([]);
};


/**
 * optional string seed = 3;
 * @return {string}
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.getSeed = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGamesBackgammonRollResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.setSeed = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string salt = 4;
 * @return {string}
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.getSalt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGamesBackgammonRollResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.setSalt = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string hash = 5;
 * @return {string}
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGamesBackgammonRollResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonRollResponse.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesBackgammonMoveRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesBackgammonMoveRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesBackgammonMoveRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesBackgammonMoveRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: jspb.Message.getFieldWithDefault(msg, 1, 0),
    to: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveRequest}
 */
proto.ClientServer.PvpGamesBackgammonMoveRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesBackgammonMoveRequest;
  return proto.ClientServer.PvpGamesBackgammonMoveRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesBackgammonMoveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveRequest}
 */
proto.ClientServer.PvpGamesBackgammonMoveRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesBackgammonMoveRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesBackgammonMoveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesBackgammonMoveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesBackgammonMoveRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTo();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 from = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesBackgammonMoveRequest.prototype.getFrom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveRequest} returns this
 */
proto.ClientServer.PvpGamesBackgammonMoveRequest.prototype.setFrom = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 to = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesBackgammonMoveRequest.prototype.getTo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveRequest} returns this
 */
proto.ClientServer.PvpGamesBackgammonMoveRequest.prototype.setTo = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesBackgammonMoveResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesBackgammonMoveResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    stepsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    numbersList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    remaining: jspb.Message.getFieldWithDefault(msg, 4, 0),
    canMove: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveResponse}
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesBackgammonMoveResponse;
  return proto.ClientServer.PvpGamesBackgammonMoveResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesBackgammonMoveResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveResponse}
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setStepsList(value);
      break;
    case 3:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setNumbersList(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRemaining(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanMove(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesBackgammonMoveResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesBackgammonMoveResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getStepsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getNumbersList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
  f = message.getRemaining();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCanMove();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated int32 steps = 2;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.getStepsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.setStepsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.addSteps = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.clearStepsList = function() {
  return this.setStepsList([]);
};


/**
 * repeated int32 numbers = 3;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.getNumbersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.setNumbersList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.addNumbers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.clearNumbersList = function() {
  return this.setNumbersList([]);
};


/**
 * optional int32 remaining = 4;
 * @return {number}
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.getRemaining = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.setRemaining = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool can_move = 5;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.getCanMove = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesBackgammonMoveResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonMoveResponse.prototype.setCanMove = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest}
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest;
  return proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest}
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.DoublingAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.DoublingAction = {
  REQUEST: 0,
  ACCEPT: 1,
  REJECT: 2
};

/**
 * optional DoublingAction action = 1;
 * @return {!proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.DoublingAction}
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.prototype.getAction = function() {
  return /** @type {!proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.DoublingAction} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.DoublingAction} value
 * @return {!proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest} returns this
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    multiplier: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse}
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse;
  return proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse}
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMultiplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMultiplier();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int32 multiplier = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.prototype.getMultiplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse} returns this
 */
proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.prototype.setMultiplier = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesStateNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesStateNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesStateNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesStateNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    room: (f = msg.getRoom()) && proto.ClientServer.PvpGameRoom.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesStateNotification}
 */
proto.ClientServer.PvpGamesStateNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesStateNotification;
  return proto.ClientServer.PvpGamesStateNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesStateNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesStateNotification}
 */
proto.ClientServer.PvpGamesStateNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ClientServer.PvpGameRoom;
      reader.readMessage(value,proto.ClientServer.PvpGameRoom.deserializeBinaryFromReader);
      msg.setRoom(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesStateNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesStateNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesStateNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesStateNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ClientServer.PvpGameRoom.serializeBinaryToWriter
    );
  }
};


/**
 * optional PvpGameRoom room = 1;
 * @return {?proto.ClientServer.PvpGameRoom}
 */
proto.ClientServer.PvpGamesStateNotification.prototype.getRoom = function() {
  return /** @type{?proto.ClientServer.PvpGameRoom} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGameRoom, 1));
};


/**
 * @param {?proto.ClientServer.PvpGameRoom|undefined} value
 * @return {!proto.ClientServer.PvpGamesStateNotification} returns this
*/
proto.ClientServer.PvpGamesStateNotification.prototype.setRoom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesStateNotification} returns this
 */
proto.ClientServer.PvpGamesStateNotification.prototype.clearRoom = function() {
  return this.setRoom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesStateNotification.prototype.hasRoom = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.NotificationCase = {
  NOTIFICATION_NOT_SET: 0,
  POKER_DECISION_WAIT_NOTIFICATION: 1,
  BACKGAMMON_DECISION_WAIT_NOTIFICATION: 2
};

/**
 * @return {proto.ClientServer.PvpGamesDecisionWaitNotification.NotificationCase}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.prototype.getNotificationCase = function() {
  return /** @type {proto.ClientServer.PvpGamesDecisionWaitNotification.NotificationCase} */(jspb.Message.computeOneofCase(this, proto.ClientServer.PvpGamesDecisionWaitNotification.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesDecisionWaitNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    pokerDecisionWaitNotification: (f = msg.getPokerDecisionWaitNotification()) && proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.toObject(includeInstance, f),
    backgammonDecisionWaitNotification: (f = msg.getBackgammonDecisionWaitNotification()) && proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesDecisionWaitNotification;
  return proto.ClientServer.PvpGamesDecisionWaitNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.deserializeBinaryFromReader);
      msg.setPokerDecisionWaitNotification(value);
      break;
    case 2:
      var value = new proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.deserializeBinaryFromReader);
      msg.setBackgammonDecisionWaitNotification(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesDecisionWaitNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPokerDecisionWaitNotification();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.serializeBinaryToWriter
    );
  }
  f = message.getBackgammonDecisionWaitNotification();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cost: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision;
  return proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCost(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCost();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional PvpGameRoom.PokerRoom.PokerAction action = 1;
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.prototype.getAction = function() {
  return /** @type {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} value
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 cost = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.prototype.getCost = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.prototype.setCost = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.toObject, includeInstance),
    defaultAction: jspb.Message.getFieldWithDefault(msg, 2, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    timeToThink: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification;
  return proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision;
      reader.readMessage(value,proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    case 2:
      var value = /** @type {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} */ (reader.readEnum());
      msg.setDefaultAction(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimeToThink(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision.serializeBinaryToWriter
    );
  }
  f = message.getDefaultAction();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTimeToThink();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated PokerDecision options = 1;
 * @return {!Array<!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision>}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision, 1));
};


/**
 * @param {!Array<!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision>} value
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification} returns this
*/
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision=} opt_value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecision, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};


/**
 * optional PvpGameRoom.PokerRoom.PokerAction default_action = 2;
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.prototype.getDefaultAction = function() {
  return /** @type {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} value
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.prototype.setDefaultAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 user_id = 3;
 * @return {number}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 time_to_think = 4;
 * @return {number}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.prototype.getTimeToThink = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification.prototype.setTimeToThink = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    optionsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    timeToThink: jspb.Message.getFieldWithDefault(msg, 3, 0),
    possibleMovesMap: (f = msg.getPossibleMovesMap()) ? f.toObject(includeInstance, proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification;
  return proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonAction>} */ (reader.readPackedEnum());
      msg.setOptionsList(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimeToThink(value);
      break;
    case 4:
      var value = msg.getPossibleMovesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.deserializeBinaryFromReader, 0, new proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTimeToThink();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPossibleMovesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.serializeBinaryToWriter);
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.toObject = function(includeInstance, msg) {
  var f, obj = {
    movesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList;
  return proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setMovesList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMovesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 moves = 1;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.prototype.getMovesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.prototype.setMovesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.prototype.addMoves = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList.prototype.clearMovesList = function() {
  return this.setMovesList([]);
};


/**
 * repeated PvpGameRoom.BackgammonRoom.BackgammonAction options = 1;
 * @return {!Array<!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonAction>}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.prototype.getOptionsList = function() {
  return /** @type {!Array<!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonAction>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonAction>} value
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.prototype.setOptionsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.ClientServer.PvpGameRoom.BackgammonRoom.BackgammonAction} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.prototype.addOptions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 time_to_think = 3;
 * @return {number}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.prototype.getTimeToThink = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.prototype.setTimeToThink = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * map<int32, MovesList> possible_moves = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList>}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.prototype.getPossibleMovesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.MovesList));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification.prototype.clearPossibleMovesMap = function() {
  this.getPossibleMovesMap().clear();
  return this;};


/**
 * optional PokerDecisionWaitNotification poker_decision_wait_notification = 1;
 * @return {?proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.prototype.getPokerDecisionWaitNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification, 1));
};


/**
 * @param {?proto.ClientServer.PvpGamesDecisionWaitNotification.PokerDecisionWaitNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification} returns this
*/
proto.ClientServer.PvpGamesDecisionWaitNotification.prototype.setPokerDecisionWaitNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.ClientServer.PvpGamesDecisionWaitNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.prototype.clearPokerDecisionWaitNotification = function() {
  return this.setPokerDecisionWaitNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.prototype.hasPokerDecisionWaitNotification = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BackgammonDecisionWaitNotification backgammon_decision_wait_notification = 2;
 * @return {?proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.prototype.getBackgammonDecisionWaitNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification, 2));
};


/**
 * @param {?proto.ClientServer.PvpGamesDecisionWaitNotification.BackgammonDecisionWaitNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification} returns this
*/
proto.ClientServer.PvpGamesDecisionWaitNotification.prototype.setBackgammonDecisionWaitNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.ClientServer.PvpGamesDecisionWaitNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesDecisionWaitNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.prototype.clearBackgammonDecisionWaitNotification = function() {
  return this.setBackgammonDecisionWaitNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesDecisionWaitNotification.prototype.hasBackgammonDecisionWaitNotification = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.NotificationCase = {
  NOTIFICATION_NOT_SET: 0,
  POKER_DECISION_MADE_NOTIFICATION: 1,
  BACKGAMMON_ROLL_MADE_NOTIFICATION: 2,
  BACKGAMMON_MOVE_MADE_NOTIFICATION: 3,
  BACKGAMMON_DOUBLING_CUBE_NOTIFICATION: 4
};

/**
 * @return {proto.ClientServer.PvpGamesDecisionMadeNotification.NotificationCase}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.getNotificationCase = function() {
  return /** @type {proto.ClientServer.PvpGamesDecisionMadeNotification.NotificationCase} */(jspb.Message.computeOneofCase(this, proto.ClientServer.PvpGamesDecisionMadeNotification.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesDecisionMadeNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    pokerDecisionMadeNotification: (f = msg.getPokerDecisionMadeNotification()) && proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.toObject(includeInstance, f),
    backgammonRollMadeNotification: (f = msg.getBackgammonRollMadeNotification()) && proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.toObject(includeInstance, f),
    backgammonMoveMadeNotification: (f = msg.getBackgammonMoveMadeNotification()) && proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.toObject(includeInstance, f),
    backgammonDoublingCubeNotification: (f = msg.getBackgammonDoublingCubeNotification()) && proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesDecisionMadeNotification;
  return proto.ClientServer.PvpGamesDecisionMadeNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.deserializeBinaryFromReader);
      msg.setPokerDecisionMadeNotification(value);
      break;
    case 2:
      var value = new proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.deserializeBinaryFromReader);
      msg.setBackgammonRollMadeNotification(value);
      break;
    case 3:
      var value = new proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.deserializeBinaryFromReader);
      msg.setBackgammonMoveMadeNotification(value);
      break;
    case 4:
      var value = new proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.deserializeBinaryFromReader);
      msg.setBackgammonDoublingCubeNotification(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesDecisionMadeNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPokerDecisionMadeNotification();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.serializeBinaryToWriter
    );
  }
  f = message.getBackgammonRollMadeNotification();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.serializeBinaryToWriter
    );
  }
  f = message.getBackgammonMoveMadeNotification();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.serializeBinaryToWriter
    );
  }
  f = message.getBackgammonDoublingCubeNotification();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification;
  return proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional PvpGameRoom.PokerRoom.PokerAction action = 1;
 * @return {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.prototype.getAction = function() {
  return /** @type {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ClientServer.PvpGameRoom.PokerRoom.PokerAction} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    numbersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    userId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification;
  return proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setNumbersList(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumbersList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated int32 numbers = 1;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.prototype.getNumbersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.prototype.setNumbersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.prototype.addNumbers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.prototype.clearNumbersList = function() {
  return this.setNumbersList([]);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.repeatedFields_ = [2,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: jspb.Message.getFieldWithDefault(msg, 1, 0),
    stepsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    userId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    numbersList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification;
  return proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setStepsList(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setNumbersList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getStepsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getNumbersList();
  if (f.length > 0) {
    writer.writePackedInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 from = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.getFrom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.setFrom = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated int32 steps = 2;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.getStepsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.setStepsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.addSteps = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.clearStepsList = function() {
  return this.setStepsList([]);
};


/**
 * optional int32 user_id = 3;
 * @return {number}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated int32 numbers = 4;
 * @return {!Array<number>}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.getNumbersList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.setNumbersList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.addNumbers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification.prototype.clearNumbersList = function() {
  return this.setNumbersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accepted: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    multiplier: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification;
  return proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccepted(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMultiplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAccepted();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMultiplier();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool accepted = 2;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.prototype.getAccepted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.prototype.setAccepted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional int32 multiplier = 3;
 * @return {number}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.prototype.getMultiplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification.prototype.setMultiplier = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional PokerDecisionMadeNotification poker_decision_made_notification = 1;
 * @return {?proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.getPokerDecisionMadeNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification, 1));
};


/**
 * @param {?proto.ClientServer.PvpGamesDecisionMadeNotification.PokerDecisionMadeNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification} returns this
*/
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.setPokerDecisionMadeNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.ClientServer.PvpGamesDecisionMadeNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.clearPokerDecisionMadeNotification = function() {
  return this.setPokerDecisionMadeNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.hasPokerDecisionMadeNotification = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BackgammonRollMadeNotification backgammon_roll_made_notification = 2;
 * @return {?proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.getBackgammonRollMadeNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification, 2));
};


/**
 * @param {?proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonRollMadeNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification} returns this
*/
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.setBackgammonRollMadeNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.ClientServer.PvpGamesDecisionMadeNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.clearBackgammonRollMadeNotification = function() {
  return this.setBackgammonRollMadeNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.hasBackgammonRollMadeNotification = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional BackgammonMoveMadeNotification backgammon_move_made_notification = 3;
 * @return {?proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.getBackgammonMoveMadeNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification, 3));
};


/**
 * @param {?proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonMoveMadeNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification} returns this
*/
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.setBackgammonMoveMadeNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.ClientServer.PvpGamesDecisionMadeNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.clearBackgammonMoveMadeNotification = function() {
  return this.setBackgammonMoveMadeNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.hasBackgammonMoveMadeNotification = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional BackgammonDoublingCubeNotification backgammon_doubling_cube_notification = 4;
 * @return {?proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.getBackgammonDoublingCubeNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification, 4));
};


/**
 * @param {?proto.ClientServer.PvpGamesDecisionMadeNotification.BackgammonDoublingCubeNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification} returns this
*/
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.setBackgammonDoublingCubeNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.ClientServer.PvpGamesDecisionMadeNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesDecisionMadeNotification} returns this
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.clearBackgammonDoublingCubeNotification = function() {
  return this.setBackgammonDoublingCubeNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesDecisionMadeNotification.prototype.hasBackgammonDoublingCubeNotification = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ClientServer.PvpGamesWinNotification.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.ClientServer.PvpGamesWinNotification.NotificationCase = {
  NOTIFICATION_NOT_SET: 0,
  BACKGAMMON_WIN_NOTIFICATION: 1
};

/**
 * @return {proto.ClientServer.PvpGamesWinNotification.NotificationCase}
 */
proto.ClientServer.PvpGamesWinNotification.prototype.getNotificationCase = function() {
  return /** @type {proto.ClientServer.PvpGamesWinNotification.NotificationCase} */(jspb.Message.computeOneofCase(this, proto.ClientServer.PvpGamesWinNotification.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesWinNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesWinNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesWinNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesWinNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    backgammonWinNotification: (f = msg.getBackgammonWinNotification()) && proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesWinNotification}
 */
proto.ClientServer.PvpGamesWinNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesWinNotification;
  return proto.ClientServer.PvpGamesWinNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesWinNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesWinNotification}
 */
proto.ClientServer.PvpGamesWinNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.deserializeBinaryFromReader);
      msg.setBackgammonWinNotification(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesWinNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesWinNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesWinNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesWinNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBackgammonWinNotification();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    score: jspb.Message.getFieldWithDefault(msg, 2, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification}
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification;
  return proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification}
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScore(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getScore();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification} returns this
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 score = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification} returns this
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.prototype.setScore = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 amount = 3;
 * @return {number}
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification} returns this
 */
proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional BackgammonWinNotification backgammon_win_notification = 1;
 * @return {?proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification}
 */
proto.ClientServer.PvpGamesWinNotification.prototype.getBackgammonWinNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification, 1));
};


/**
 * @param {?proto.ClientServer.PvpGamesWinNotification.BackgammonWinNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesWinNotification} returns this
*/
proto.ClientServer.PvpGamesWinNotification.prototype.setBackgammonWinNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.ClientServer.PvpGamesWinNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesWinNotification} returns this
 */
proto.ClientServer.PvpGamesWinNotification.prototype.clearBackgammonWinNotification = function() {
  return this.setBackgammonWinNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesWinNotification.prototype.hasBackgammonWinNotification = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesKickoutNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesKickoutNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesKickoutNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesKickoutNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesKickoutNotification}
 */
proto.ClientServer.PvpGamesKickoutNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesKickoutNotification;
  return proto.ClientServer.PvpGamesKickoutNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesKickoutNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesKickoutNotification}
 */
proto.ClientServer.PvpGamesKickoutNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesKickoutNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesKickoutNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesKickoutNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesKickoutNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesKickoutNotification.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesKickoutNotification} returns this
 */
proto.ClientServer.PvpGamesKickoutNotification.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.ClientServer.PvpGamesKickoutNotification.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGamesKickoutNotification} returns this
 */
proto.ClientServer.PvpGamesKickoutNotification.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesRoomTerminatedNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesRoomTerminatedNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesRoomTerminatedNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesRoomTerminatedNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesRoomTerminatedNotification}
 */
proto.ClientServer.PvpGamesRoomTerminatedNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesRoomTerminatedNotification;
  return proto.ClientServer.PvpGamesRoomTerminatedNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesRoomTerminatedNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesRoomTerminatedNotification}
 */
proto.ClientServer.PvpGamesRoomTerminatedNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoomId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesRoomTerminatedNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesRoomTerminatedNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesRoomTerminatedNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesRoomTerminatedNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 room_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesRoomTerminatedNotification.prototype.getRoomId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesRoomTerminatedNotification} returns this
 */
proto.ClientServer.PvpGamesRoomTerminatedNotification.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesPlayerJoinNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesPlayerJoinNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesPlayerJoinNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesPlayerJoinNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tableId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesPlayerJoinNotification}
 */
proto.ClientServer.PvpGamesPlayerJoinNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesPlayerJoinNotification;
  return proto.ClientServer.PvpGamesPlayerJoinNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesPlayerJoinNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesPlayerJoinNotification}
 */
proto.ClientServer.PvpGamesPlayerJoinNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoomId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTableId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesPlayerJoinNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesPlayerJoinNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesPlayerJoinNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesPlayerJoinNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTableId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 room_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesPlayerJoinNotification.prototype.getRoomId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesPlayerJoinNotification} returns this
 */
proto.ClientServer.PvpGamesPlayerJoinNotification.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 table_id = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesPlayerJoinNotification.prototype.getTableId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesPlayerJoinNotification} returns this
 */
proto.ClientServer.PvpGamesPlayerJoinNotification.prototype.setTableId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 user_id = 3;
 * @return {number}
 */
proto.ClientServer.PvpGamesPlayerJoinNotification.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesPlayerJoinNotification} returns this
 */
proto.ClientServer.PvpGamesPlayerJoinNotification.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesInvitationReceivedNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesInvitationReceivedNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    gameId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    roomId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    hash: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesInvitationReceivedNotification}
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesInvitationReceivedNotification;
  return proto.ClientServer.PvpGamesInvitationReceivedNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesInvitationReceivedNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesInvitationReceivedNotification}
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGameId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoomId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesInvitationReceivedNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesInvitationReceivedNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getGameId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRoomId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesInvitationReceivedNotification} returns this
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 game_id = 2;
 * @return {number}
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.prototype.getGameId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesInvitationReceivedNotification} returns this
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.prototype.setGameId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 room_id = 3;
 * @return {number}
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.prototype.getRoomId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesInvitationReceivedNotification} returns this
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string hash = 4;
 * @return {string}
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGamesInvitationReceivedNotification} returns this
 */
proto.ClientServer.PvpGamesInvitationReceivedNotification.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesInvitationResponseNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesInvitationResponseNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesInvitationResponseNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesInvitationResponseNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    opponentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hash: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accepted: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesInvitationResponseNotification}
 */
proto.ClientServer.PvpGamesInvitationResponseNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesInvitationResponseNotification;
  return proto.ClientServer.PvpGamesInvitationResponseNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesInvitationResponseNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesInvitationResponseNotification}
 */
proto.ClientServer.PvpGamesInvitationResponseNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOpponentId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccepted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesInvitationResponseNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesInvitationResponseNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesInvitationResponseNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesInvitationResponseNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpponentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccepted();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional int32 opponent_id = 1;
 * @return {number}
 */
proto.ClientServer.PvpGamesInvitationResponseNotification.prototype.getOpponentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PvpGamesInvitationResponseNotification} returns this
 */
proto.ClientServer.PvpGamesInvitationResponseNotification.prototype.setOpponentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string hash = 3;
 * @return {string}
 */
proto.ClientServer.PvpGamesInvitationResponseNotification.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.PvpGamesInvitationResponseNotification} returns this
 */
proto.ClientServer.PvpGamesInvitationResponseNotification.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool accepted = 4;
 * @return {boolean}
 */
proto.ClientServer.PvpGamesInvitationResponseNotification.prototype.getAccepted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.PvpGamesInvitationResponseNotification} returns this
 */
proto.ClientServer.PvpGamesInvitationResponseNotification.prototype.setAccepted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ClientServer.PvpGamesRoomNotification.oneofGroups_ = [[1,2,3,4,5,6,7,8,9]];

/**
 * @enum {number}
 */
proto.ClientServer.PvpGamesRoomNotification.NotificationCase = {
  NOTIFICATION_NOT_SET: 0,
  PVP_GAMES_STATE_NOTIFICATION: 1,
  PVP_GAMES_DECISION_WAIT_NOTIFICATION: 2,
  PVP_GAMES_DECISION_MADE_NOTIFICATION: 3,
  PVP_GAMES_WIN_NOTIFICATION: 4,
  PVP_GAMES_KICKOUT_NOTIFICATION: 5,
  PVP_GAMES_ROOM_TERMINATED_NOTIFICATION: 6,
  PVP_GAMES_PLAYER_JOIN_NOTIFICATION: 7,
  PVP_GAMES_INVITATION_RECEIVED_NOTIFICATION: 8,
  PVP_GAMES_INVITATION_RESPONSE_NOTIFICATION: 9
};

/**
 * @return {proto.ClientServer.PvpGamesRoomNotification.NotificationCase}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.getNotificationCase = function() {
  return /** @type {proto.ClientServer.PvpGamesRoomNotification.NotificationCase} */(jspb.Message.computeOneofCase(this, proto.ClientServer.PvpGamesRoomNotification.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PvpGamesRoomNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PvpGamesRoomNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesRoomNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    pvpGamesStateNotification: (f = msg.getPvpGamesStateNotification()) && proto.ClientServer.PvpGamesStateNotification.toObject(includeInstance, f),
    pvpGamesDecisionWaitNotification: (f = msg.getPvpGamesDecisionWaitNotification()) && proto.ClientServer.PvpGamesDecisionWaitNotification.toObject(includeInstance, f),
    pvpGamesDecisionMadeNotification: (f = msg.getPvpGamesDecisionMadeNotification()) && proto.ClientServer.PvpGamesDecisionMadeNotification.toObject(includeInstance, f),
    pvpGamesWinNotification: (f = msg.getPvpGamesWinNotification()) && proto.ClientServer.PvpGamesWinNotification.toObject(includeInstance, f),
    pvpGamesKickoutNotification: (f = msg.getPvpGamesKickoutNotification()) && proto.ClientServer.PvpGamesKickoutNotification.toObject(includeInstance, f),
    pvpGamesRoomTerminatedNotification: (f = msg.getPvpGamesRoomTerminatedNotification()) && proto.ClientServer.PvpGamesRoomTerminatedNotification.toObject(includeInstance, f),
    pvpGamesPlayerJoinNotification: (f = msg.getPvpGamesPlayerJoinNotification()) && proto.ClientServer.PvpGamesPlayerJoinNotification.toObject(includeInstance, f),
    pvpGamesInvitationReceivedNotification: (f = msg.getPvpGamesInvitationReceivedNotification()) && proto.ClientServer.PvpGamesInvitationReceivedNotification.toObject(includeInstance, f),
    pvpGamesInvitationResponseNotification: (f = msg.getPvpGamesInvitationResponseNotification()) && proto.ClientServer.PvpGamesInvitationResponseNotification.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PvpGamesRoomNotification}
 */
proto.ClientServer.PvpGamesRoomNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PvpGamesRoomNotification;
  return proto.ClientServer.PvpGamesRoomNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PvpGamesRoomNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PvpGamesRoomNotification}
 */
proto.ClientServer.PvpGamesRoomNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ClientServer.PvpGamesStateNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesStateNotification.deserializeBinaryFromReader);
      msg.setPvpGamesStateNotification(value);
      break;
    case 2:
      var value = new proto.ClientServer.PvpGamesDecisionWaitNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesDecisionWaitNotification.deserializeBinaryFromReader);
      msg.setPvpGamesDecisionWaitNotification(value);
      break;
    case 3:
      var value = new proto.ClientServer.PvpGamesDecisionMadeNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesDecisionMadeNotification.deserializeBinaryFromReader);
      msg.setPvpGamesDecisionMadeNotification(value);
      break;
    case 4:
      var value = new proto.ClientServer.PvpGamesWinNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesWinNotification.deserializeBinaryFromReader);
      msg.setPvpGamesWinNotification(value);
      break;
    case 5:
      var value = new proto.ClientServer.PvpGamesKickoutNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesKickoutNotification.deserializeBinaryFromReader);
      msg.setPvpGamesKickoutNotification(value);
      break;
    case 6:
      var value = new proto.ClientServer.PvpGamesRoomTerminatedNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesRoomTerminatedNotification.deserializeBinaryFromReader);
      msg.setPvpGamesRoomTerminatedNotification(value);
      break;
    case 7:
      var value = new proto.ClientServer.PvpGamesPlayerJoinNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesPlayerJoinNotification.deserializeBinaryFromReader);
      msg.setPvpGamesPlayerJoinNotification(value);
      break;
    case 8:
      var value = new proto.ClientServer.PvpGamesInvitationReceivedNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesInvitationReceivedNotification.deserializeBinaryFromReader);
      msg.setPvpGamesInvitationReceivedNotification(value);
      break;
    case 9:
      var value = new proto.ClientServer.PvpGamesInvitationResponseNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesInvitationResponseNotification.deserializeBinaryFromReader);
      msg.setPvpGamesInvitationResponseNotification(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PvpGamesRoomNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PvpGamesRoomNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PvpGamesRoomNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPvpGamesStateNotification();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ClientServer.PvpGamesStateNotification.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesDecisionWaitNotification();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ClientServer.PvpGamesDecisionWaitNotification.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesDecisionMadeNotification();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ClientServer.PvpGamesDecisionMadeNotification.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesWinNotification();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ClientServer.PvpGamesWinNotification.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesKickoutNotification();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ClientServer.PvpGamesKickoutNotification.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesRoomTerminatedNotification();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ClientServer.PvpGamesRoomTerminatedNotification.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesPlayerJoinNotification();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ClientServer.PvpGamesPlayerJoinNotification.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesInvitationReceivedNotification();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ClientServer.PvpGamesInvitationReceivedNotification.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesInvitationResponseNotification();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ClientServer.PvpGamesInvitationResponseNotification.serializeBinaryToWriter
    );
  }
};


/**
 * optional PvpGamesStateNotification pvp_games_state_notification = 1;
 * @return {?proto.ClientServer.PvpGamesStateNotification}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.getPvpGamesStateNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesStateNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesStateNotification, 1));
};


/**
 * @param {?proto.ClientServer.PvpGamesStateNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
*/
proto.ClientServer.PvpGamesRoomNotification.prototype.setPvpGamesStateNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.ClientServer.PvpGamesRoomNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.clearPvpGamesStateNotification = function() {
  return this.setPvpGamesStateNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.hasPvpGamesStateNotification = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PvpGamesDecisionWaitNotification pvp_games_decision_wait_notification = 2;
 * @return {?proto.ClientServer.PvpGamesDecisionWaitNotification}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.getPvpGamesDecisionWaitNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesDecisionWaitNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesDecisionWaitNotification, 2));
};


/**
 * @param {?proto.ClientServer.PvpGamesDecisionWaitNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
*/
proto.ClientServer.PvpGamesRoomNotification.prototype.setPvpGamesDecisionWaitNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.ClientServer.PvpGamesRoomNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.clearPvpGamesDecisionWaitNotification = function() {
  return this.setPvpGamesDecisionWaitNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.hasPvpGamesDecisionWaitNotification = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PvpGamesDecisionMadeNotification pvp_games_decision_made_notification = 3;
 * @return {?proto.ClientServer.PvpGamesDecisionMadeNotification}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.getPvpGamesDecisionMadeNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesDecisionMadeNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesDecisionMadeNotification, 3));
};


/**
 * @param {?proto.ClientServer.PvpGamesDecisionMadeNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
*/
proto.ClientServer.PvpGamesRoomNotification.prototype.setPvpGamesDecisionMadeNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.ClientServer.PvpGamesRoomNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.clearPvpGamesDecisionMadeNotification = function() {
  return this.setPvpGamesDecisionMadeNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.hasPvpGamesDecisionMadeNotification = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PvpGamesWinNotification pvp_games_win_notification = 4;
 * @return {?proto.ClientServer.PvpGamesWinNotification}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.getPvpGamesWinNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesWinNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesWinNotification, 4));
};


/**
 * @param {?proto.ClientServer.PvpGamesWinNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
*/
proto.ClientServer.PvpGamesRoomNotification.prototype.setPvpGamesWinNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.ClientServer.PvpGamesRoomNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.clearPvpGamesWinNotification = function() {
  return this.setPvpGamesWinNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.hasPvpGamesWinNotification = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PvpGamesKickoutNotification pvp_games_kickout_notification = 5;
 * @return {?proto.ClientServer.PvpGamesKickoutNotification}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.getPvpGamesKickoutNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesKickoutNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesKickoutNotification, 5));
};


/**
 * @param {?proto.ClientServer.PvpGamesKickoutNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
*/
proto.ClientServer.PvpGamesRoomNotification.prototype.setPvpGamesKickoutNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.ClientServer.PvpGamesRoomNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.clearPvpGamesKickoutNotification = function() {
  return this.setPvpGamesKickoutNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.hasPvpGamesKickoutNotification = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PvpGamesRoomTerminatedNotification pvp_games_room_terminated_notification = 6;
 * @return {?proto.ClientServer.PvpGamesRoomTerminatedNotification}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.getPvpGamesRoomTerminatedNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesRoomTerminatedNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesRoomTerminatedNotification, 6));
};


/**
 * @param {?proto.ClientServer.PvpGamesRoomTerminatedNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
*/
proto.ClientServer.PvpGamesRoomNotification.prototype.setPvpGamesRoomTerminatedNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.ClientServer.PvpGamesRoomNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.clearPvpGamesRoomTerminatedNotification = function() {
  return this.setPvpGamesRoomTerminatedNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.hasPvpGamesRoomTerminatedNotification = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional PvpGamesPlayerJoinNotification pvp_games_player_join_notification = 7;
 * @return {?proto.ClientServer.PvpGamesPlayerJoinNotification}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.getPvpGamesPlayerJoinNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesPlayerJoinNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesPlayerJoinNotification, 7));
};


/**
 * @param {?proto.ClientServer.PvpGamesPlayerJoinNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
*/
proto.ClientServer.PvpGamesRoomNotification.prototype.setPvpGamesPlayerJoinNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.ClientServer.PvpGamesRoomNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.clearPvpGamesPlayerJoinNotification = function() {
  return this.setPvpGamesPlayerJoinNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.hasPvpGamesPlayerJoinNotification = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional PvpGamesInvitationReceivedNotification pvp_games_invitation_received_notification = 8;
 * @return {?proto.ClientServer.PvpGamesInvitationReceivedNotification}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.getPvpGamesInvitationReceivedNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesInvitationReceivedNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesInvitationReceivedNotification, 8));
};


/**
 * @param {?proto.ClientServer.PvpGamesInvitationReceivedNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
*/
proto.ClientServer.PvpGamesRoomNotification.prototype.setPvpGamesInvitationReceivedNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.ClientServer.PvpGamesRoomNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.clearPvpGamesInvitationReceivedNotification = function() {
  return this.setPvpGamesInvitationReceivedNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.hasPvpGamesInvitationReceivedNotification = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional PvpGamesInvitationResponseNotification pvp_games_invitation_response_notification = 9;
 * @return {?proto.ClientServer.PvpGamesInvitationResponseNotification}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.getPvpGamesInvitationResponseNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesInvitationResponseNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesInvitationResponseNotification, 9));
};


/**
 * @param {?proto.ClientServer.PvpGamesInvitationResponseNotification|undefined} value
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
*/
proto.ClientServer.PvpGamesRoomNotification.prototype.setPvpGamesInvitationResponseNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.ClientServer.PvpGamesRoomNotification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.PvpGamesRoomNotification} returns this
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.clearPvpGamesInvitationResponseNotification = function() {
  return this.setPvpGamesInvitationResponseNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.PvpGamesRoomNotification.prototype.hasPvpGamesInvitationResponseNotification = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PlayerBalanceChangeNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PlayerBalanceChangeNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PlayerBalanceChangeNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PlayerBalanceChangeNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    balance: jspb.Message.getFieldWithDefault(msg, 1, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PlayerBalanceChangeNotification}
 */
proto.ClientServer.PlayerBalanceChangeNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PlayerBalanceChangeNotification;
  return proto.ClientServer.PlayerBalanceChangeNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PlayerBalanceChangeNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PlayerBalanceChangeNotification}
 */
proto.ClientServer.PlayerBalanceChangeNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBalance(value);
      break;
    case 2:
      var value = /** @type {!proto.ClientServer.PlayerBalanceChangeNotification.Reason} */ (reader.readEnum());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PlayerBalanceChangeNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PlayerBalanceChangeNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PlayerBalanceChangeNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PlayerBalanceChangeNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBalance();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ClientServer.PlayerBalanceChangeNotification.Reason = {
  AUTO_BET: 0,
  WIN: 1,
  CANCEL_BET: 2,
  CHECK: 3,
  EXTERNAL: 4
};

/**
 * optional int32 balance = 1;
 * @return {number}
 */
proto.ClientServer.PlayerBalanceChangeNotification.prototype.getBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.PlayerBalanceChangeNotification} returns this
 */
proto.ClientServer.PlayerBalanceChangeNotification.prototype.setBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Reason reason = 2;
 * @return {!proto.ClientServer.PlayerBalanceChangeNotification.Reason}
 */
proto.ClientServer.PlayerBalanceChangeNotification.prototype.getReason = function() {
  return /** @type {!proto.ClientServer.PlayerBalanceChangeNotification.Reason} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ClientServer.PlayerBalanceChangeNotification.Reason} value
 * @return {!proto.ClientServer.PlayerBalanceChangeNotification} returns this
 */
proto.ClientServer.PlayerBalanceChangeNotification.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.UserDisconnectNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.UserDisconnectNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.UserDisconnectNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.UserDisconnectNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    reason: jspb.Message.getFieldWithDefault(msg, 1, 0),
    var1: jspb.Message.getFieldWithDefault(msg, 2, 0),
    var2: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.UserDisconnectNotification}
 */
proto.ClientServer.UserDisconnectNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.UserDisconnectNotification;
  return proto.ClientServer.UserDisconnectNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.UserDisconnectNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.UserDisconnectNotification}
 */
proto.ClientServer.UserDisconnectNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ClientServer.UserDisconnectNotification.Reason} */ (reader.readEnum());
      msg.setReason(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVar1(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVar2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.UserDisconnectNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.UserDisconnectNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.UserDisconnectNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.UserDisconnectNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getVar1();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getVar2();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ClientServer.UserDisconnectNotification.Reason = {
  CROSS_CONNECT: 0,
  PANIC: 1,
  OTHER: 2
};

/**
 * optional Reason reason = 1;
 * @return {!proto.ClientServer.UserDisconnectNotification.Reason}
 */
proto.ClientServer.UserDisconnectNotification.prototype.getReason = function() {
  return /** @type {!proto.ClientServer.UserDisconnectNotification.Reason} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ClientServer.UserDisconnectNotification.Reason} value
 * @return {!proto.ClientServer.UserDisconnectNotification} returns this
 */
proto.ClientServer.UserDisconnectNotification.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 var_1 = 2;
 * @return {number}
 */
proto.ClientServer.UserDisconnectNotification.prototype.getVar1 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.UserDisconnectNotification} returns this
 */
proto.ClientServer.UserDisconnectNotification.prototype.setVar1 = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string var_2 = 3;
 * @return {string}
 */
proto.ClientServer.UserDisconnectNotification.prototype.getVar2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.UserDisconnectNotification} returns this
 */
proto.ClientServer.UserDisconnectNotification.prototype.setVar2 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ClientServer.GameCommandRequest.oneofGroups_ = [[2,3,4,5,6,7,8,9,10,11,12,13]];

/**
 * @enum {number}
 */
proto.ClientServer.GameCommandRequest.RequestCase = {
  REQUEST_NOT_SET: 0,
  PVP_GAMES_LIST_USERS_REQUEST: 2,
  PVP_GAMES_INVITE_OPPONENT_REQUEST: 3,
  PVP_GAMES_ACCEPT_INVITATION_REQUEST: 4,
  PVP_GAMES_LIST_ROOMS_REQUEST: 5,
  PVP_GAMES_WATCH_ROOM_REQUEST: 6,
  PVP_GAMES_PLAY_ROOM_REQUEST: 7,
  PVP_GAMES_POKER_BET_REQUEST: 8,
  PVP_GAMES_EXIT_ROOM_REQUEST: 9,
  PVP_GAMES_BACKGAMMON_ROLL_REQUEST: 10,
  PVP_GAMES_BACKGAMMON_MOVE_REQUEST: 11,
  PVP_GAMES_BACKGAMMON_DOUBLING_CUBE_REQUEST: 12,
  PVP_GAMES_LIST_TOURNAMENTS_REQUEST: 13
};

/**
 * @return {proto.ClientServer.GameCommandRequest.RequestCase}
 */
proto.ClientServer.GameCommandRequest.prototype.getRequestCase = function() {
  return /** @type {proto.ClientServer.GameCommandRequest.RequestCase} */(jspb.Message.computeOneofCase(this, proto.ClientServer.GameCommandRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.GameCommandRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.GameCommandRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.GameCommandRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.GameCommandRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    gameId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pvpGamesListUsersRequest: (f = msg.getPvpGamesListUsersRequest()) && proto.ClientServer.PvpGamesListUsersRequest.toObject(includeInstance, f),
    pvpGamesInviteOpponentRequest: (f = msg.getPvpGamesInviteOpponentRequest()) && proto.ClientServer.PvpGamesInviteOpponentRequest.toObject(includeInstance, f),
    pvpGamesAcceptInvitationRequest: (f = msg.getPvpGamesAcceptInvitationRequest()) && proto.ClientServer.PvpGamesAcceptInvitationRequest.toObject(includeInstance, f),
    pvpGamesListRoomsRequest: (f = msg.getPvpGamesListRoomsRequest()) && proto.ClientServer.PvpGamesListRoomsRequest.toObject(includeInstance, f),
    pvpGamesWatchRoomRequest: (f = msg.getPvpGamesWatchRoomRequest()) && proto.ClientServer.PvpGamesWatchRoomRequest.toObject(includeInstance, f),
    pvpGamesPlayRoomRequest: (f = msg.getPvpGamesPlayRoomRequest()) && proto.ClientServer.PvpGamesPlayRoomRequest.toObject(includeInstance, f),
    pvpGamesPokerBetRequest: (f = msg.getPvpGamesPokerBetRequest()) && proto.ClientServer.PvpGamesPokerBetRequest.toObject(includeInstance, f),
    pvpGamesExitRoomRequest: (f = msg.getPvpGamesExitRoomRequest()) && proto.ClientServer.PvpGamesExitRoomRequest.toObject(includeInstance, f),
    pvpGamesBackgammonRollRequest: (f = msg.getPvpGamesBackgammonRollRequest()) && proto.ClientServer.PvpGamesBackgammonRollRequest.toObject(includeInstance, f),
    pvpGamesBackgammonMoveRequest: (f = msg.getPvpGamesBackgammonMoveRequest()) && proto.ClientServer.PvpGamesBackgammonMoveRequest.toObject(includeInstance, f),
    pvpGamesBackgammonDoublingCubeRequest: (f = msg.getPvpGamesBackgammonDoublingCubeRequest()) && proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.toObject(includeInstance, f),
    pvpGamesListTournamentsRequest: (f = msg.getPvpGamesListTournamentsRequest()) && proto.ClientServer.PvpGamesListTournamentsRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.GameCommandRequest}
 */
proto.ClientServer.GameCommandRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.GameCommandRequest;
  return proto.ClientServer.GameCommandRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.GameCommandRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.GameCommandRequest}
 */
proto.ClientServer.GameCommandRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGameId(value);
      break;
    case 2:
      var value = new proto.ClientServer.PvpGamesListUsersRequest;
      reader.readMessage(value,proto.ClientServer.PvpGamesListUsersRequest.deserializeBinaryFromReader);
      msg.setPvpGamesListUsersRequest(value);
      break;
    case 3:
      var value = new proto.ClientServer.PvpGamesInviteOpponentRequest;
      reader.readMessage(value,proto.ClientServer.PvpGamesInviteOpponentRequest.deserializeBinaryFromReader);
      msg.setPvpGamesInviteOpponentRequest(value);
      break;
    case 4:
      var value = new proto.ClientServer.PvpGamesAcceptInvitationRequest;
      reader.readMessage(value,proto.ClientServer.PvpGamesAcceptInvitationRequest.deserializeBinaryFromReader);
      msg.setPvpGamesAcceptInvitationRequest(value);
      break;
    case 5:
      var value = new proto.ClientServer.PvpGamesListRoomsRequest;
      reader.readMessage(value,proto.ClientServer.PvpGamesListRoomsRequest.deserializeBinaryFromReader);
      msg.setPvpGamesListRoomsRequest(value);
      break;
    case 6:
      var value = new proto.ClientServer.PvpGamesWatchRoomRequest;
      reader.readMessage(value,proto.ClientServer.PvpGamesWatchRoomRequest.deserializeBinaryFromReader);
      msg.setPvpGamesWatchRoomRequest(value);
      break;
    case 7:
      var value = new proto.ClientServer.PvpGamesPlayRoomRequest;
      reader.readMessage(value,proto.ClientServer.PvpGamesPlayRoomRequest.deserializeBinaryFromReader);
      msg.setPvpGamesPlayRoomRequest(value);
      break;
    case 8:
      var value = new proto.ClientServer.PvpGamesPokerBetRequest;
      reader.readMessage(value,proto.ClientServer.PvpGamesPokerBetRequest.deserializeBinaryFromReader);
      msg.setPvpGamesPokerBetRequest(value);
      break;
    case 9:
      var value = new proto.ClientServer.PvpGamesExitRoomRequest;
      reader.readMessage(value,proto.ClientServer.PvpGamesExitRoomRequest.deserializeBinaryFromReader);
      msg.setPvpGamesExitRoomRequest(value);
      break;
    case 10:
      var value = new proto.ClientServer.PvpGamesBackgammonRollRequest;
      reader.readMessage(value,proto.ClientServer.PvpGamesBackgammonRollRequest.deserializeBinaryFromReader);
      msg.setPvpGamesBackgammonRollRequest(value);
      break;
    case 11:
      var value = new proto.ClientServer.PvpGamesBackgammonMoveRequest;
      reader.readMessage(value,proto.ClientServer.PvpGamesBackgammonMoveRequest.deserializeBinaryFromReader);
      msg.setPvpGamesBackgammonMoveRequest(value);
      break;
    case 12:
      var value = new proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest;
      reader.readMessage(value,proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.deserializeBinaryFromReader);
      msg.setPvpGamesBackgammonDoublingCubeRequest(value);
      break;
    case 13:
      var value = new proto.ClientServer.PvpGamesListTournamentsRequest;
      reader.readMessage(value,proto.ClientServer.PvpGamesListTournamentsRequest.deserializeBinaryFromReader);
      msg.setPvpGamesListTournamentsRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.GameCommandRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.GameCommandRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.GameCommandRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.GameCommandRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPvpGamesListUsersRequest();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ClientServer.PvpGamesListUsersRequest.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesInviteOpponentRequest();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ClientServer.PvpGamesInviteOpponentRequest.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesAcceptInvitationRequest();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ClientServer.PvpGamesAcceptInvitationRequest.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesListRoomsRequest();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ClientServer.PvpGamesListRoomsRequest.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesWatchRoomRequest();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ClientServer.PvpGamesWatchRoomRequest.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesPlayRoomRequest();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ClientServer.PvpGamesPlayRoomRequest.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesPokerBetRequest();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ClientServer.PvpGamesPokerBetRequest.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesExitRoomRequest();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ClientServer.PvpGamesExitRoomRequest.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesBackgammonRollRequest();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ClientServer.PvpGamesBackgammonRollRequest.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesBackgammonMoveRequest();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.ClientServer.PvpGamesBackgammonMoveRequest.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesBackgammonDoublingCubeRequest();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesListTournamentsRequest();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.ClientServer.PvpGamesListTournamentsRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 game_id = 1;
 * @return {number}
 */
proto.ClientServer.GameCommandRequest.prototype.getGameId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.setGameId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional PvpGamesListUsersRequest pvp_games_list_users_request = 2;
 * @return {?proto.ClientServer.PvpGamesListUsersRequest}
 */
proto.ClientServer.GameCommandRequest.prototype.getPvpGamesListUsersRequest = function() {
  return /** @type{?proto.ClientServer.PvpGamesListUsersRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesListUsersRequest, 2));
};


/**
 * @param {?proto.ClientServer.PvpGamesListUsersRequest|undefined} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
*/
proto.ClientServer.GameCommandRequest.prototype.setPvpGamesListUsersRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.ClientServer.GameCommandRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.clearPvpGamesListUsersRequest = function() {
  return this.setPvpGamesListUsersRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandRequest.prototype.hasPvpGamesListUsersRequest = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PvpGamesInviteOpponentRequest pvp_games_invite_opponent_request = 3;
 * @return {?proto.ClientServer.PvpGamesInviteOpponentRequest}
 */
proto.ClientServer.GameCommandRequest.prototype.getPvpGamesInviteOpponentRequest = function() {
  return /** @type{?proto.ClientServer.PvpGamesInviteOpponentRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesInviteOpponentRequest, 3));
};


/**
 * @param {?proto.ClientServer.PvpGamesInviteOpponentRequest|undefined} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
*/
proto.ClientServer.GameCommandRequest.prototype.setPvpGamesInviteOpponentRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.ClientServer.GameCommandRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.clearPvpGamesInviteOpponentRequest = function() {
  return this.setPvpGamesInviteOpponentRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandRequest.prototype.hasPvpGamesInviteOpponentRequest = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PvpGamesAcceptInvitationRequest pvp_games_accept_invitation_request = 4;
 * @return {?proto.ClientServer.PvpGamesAcceptInvitationRequest}
 */
proto.ClientServer.GameCommandRequest.prototype.getPvpGamesAcceptInvitationRequest = function() {
  return /** @type{?proto.ClientServer.PvpGamesAcceptInvitationRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesAcceptInvitationRequest, 4));
};


/**
 * @param {?proto.ClientServer.PvpGamesAcceptInvitationRequest|undefined} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
*/
proto.ClientServer.GameCommandRequest.prototype.setPvpGamesAcceptInvitationRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.ClientServer.GameCommandRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.clearPvpGamesAcceptInvitationRequest = function() {
  return this.setPvpGamesAcceptInvitationRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandRequest.prototype.hasPvpGamesAcceptInvitationRequest = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PvpGamesListRoomsRequest pvp_games_list_rooms_request = 5;
 * @return {?proto.ClientServer.PvpGamesListRoomsRequest}
 */
proto.ClientServer.GameCommandRequest.prototype.getPvpGamesListRoomsRequest = function() {
  return /** @type{?proto.ClientServer.PvpGamesListRoomsRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesListRoomsRequest, 5));
};


/**
 * @param {?proto.ClientServer.PvpGamesListRoomsRequest|undefined} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
*/
proto.ClientServer.GameCommandRequest.prototype.setPvpGamesListRoomsRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.ClientServer.GameCommandRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.clearPvpGamesListRoomsRequest = function() {
  return this.setPvpGamesListRoomsRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandRequest.prototype.hasPvpGamesListRoomsRequest = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PvpGamesWatchRoomRequest pvp_games_watch_room_request = 6;
 * @return {?proto.ClientServer.PvpGamesWatchRoomRequest}
 */
proto.ClientServer.GameCommandRequest.prototype.getPvpGamesWatchRoomRequest = function() {
  return /** @type{?proto.ClientServer.PvpGamesWatchRoomRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesWatchRoomRequest, 6));
};


/**
 * @param {?proto.ClientServer.PvpGamesWatchRoomRequest|undefined} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
*/
proto.ClientServer.GameCommandRequest.prototype.setPvpGamesWatchRoomRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.ClientServer.GameCommandRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.clearPvpGamesWatchRoomRequest = function() {
  return this.setPvpGamesWatchRoomRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandRequest.prototype.hasPvpGamesWatchRoomRequest = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional PvpGamesPlayRoomRequest pvp_games_play_room_request = 7;
 * @return {?proto.ClientServer.PvpGamesPlayRoomRequest}
 */
proto.ClientServer.GameCommandRequest.prototype.getPvpGamesPlayRoomRequest = function() {
  return /** @type{?proto.ClientServer.PvpGamesPlayRoomRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesPlayRoomRequest, 7));
};


/**
 * @param {?proto.ClientServer.PvpGamesPlayRoomRequest|undefined} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
*/
proto.ClientServer.GameCommandRequest.prototype.setPvpGamesPlayRoomRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.ClientServer.GameCommandRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.clearPvpGamesPlayRoomRequest = function() {
  return this.setPvpGamesPlayRoomRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandRequest.prototype.hasPvpGamesPlayRoomRequest = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional PvpGamesPokerBetRequest pvp_games_poker_bet_request = 8;
 * @return {?proto.ClientServer.PvpGamesPokerBetRequest}
 */
proto.ClientServer.GameCommandRequest.prototype.getPvpGamesPokerBetRequest = function() {
  return /** @type{?proto.ClientServer.PvpGamesPokerBetRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesPokerBetRequest, 8));
};


/**
 * @param {?proto.ClientServer.PvpGamesPokerBetRequest|undefined} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
*/
proto.ClientServer.GameCommandRequest.prototype.setPvpGamesPokerBetRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.ClientServer.GameCommandRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.clearPvpGamesPokerBetRequest = function() {
  return this.setPvpGamesPokerBetRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandRequest.prototype.hasPvpGamesPokerBetRequest = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional PvpGamesExitRoomRequest pvp_games_exit_room_request = 9;
 * @return {?proto.ClientServer.PvpGamesExitRoomRequest}
 */
proto.ClientServer.GameCommandRequest.prototype.getPvpGamesExitRoomRequest = function() {
  return /** @type{?proto.ClientServer.PvpGamesExitRoomRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesExitRoomRequest, 9));
};


/**
 * @param {?proto.ClientServer.PvpGamesExitRoomRequest|undefined} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
*/
proto.ClientServer.GameCommandRequest.prototype.setPvpGamesExitRoomRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.ClientServer.GameCommandRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.clearPvpGamesExitRoomRequest = function() {
  return this.setPvpGamesExitRoomRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandRequest.prototype.hasPvpGamesExitRoomRequest = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional PvpGamesBackgammonRollRequest pvp_games_backgammon_roll_request = 10;
 * @return {?proto.ClientServer.PvpGamesBackgammonRollRequest}
 */
proto.ClientServer.GameCommandRequest.prototype.getPvpGamesBackgammonRollRequest = function() {
  return /** @type{?proto.ClientServer.PvpGamesBackgammonRollRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesBackgammonRollRequest, 10));
};


/**
 * @param {?proto.ClientServer.PvpGamesBackgammonRollRequest|undefined} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
*/
proto.ClientServer.GameCommandRequest.prototype.setPvpGamesBackgammonRollRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.ClientServer.GameCommandRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.clearPvpGamesBackgammonRollRequest = function() {
  return this.setPvpGamesBackgammonRollRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandRequest.prototype.hasPvpGamesBackgammonRollRequest = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional PvpGamesBackgammonMoveRequest pvp_games_backgammon_move_request = 11;
 * @return {?proto.ClientServer.PvpGamesBackgammonMoveRequest}
 */
proto.ClientServer.GameCommandRequest.prototype.getPvpGamesBackgammonMoveRequest = function() {
  return /** @type{?proto.ClientServer.PvpGamesBackgammonMoveRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesBackgammonMoveRequest, 11));
};


/**
 * @param {?proto.ClientServer.PvpGamesBackgammonMoveRequest|undefined} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
*/
proto.ClientServer.GameCommandRequest.prototype.setPvpGamesBackgammonMoveRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.ClientServer.GameCommandRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.clearPvpGamesBackgammonMoveRequest = function() {
  return this.setPvpGamesBackgammonMoveRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandRequest.prototype.hasPvpGamesBackgammonMoveRequest = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional PvpGamesBackgammonDoublingCubeRequest pvp_games_backgammon_doubling_cube_request = 12;
 * @return {?proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest}
 */
proto.ClientServer.GameCommandRequest.prototype.getPvpGamesBackgammonDoublingCubeRequest = function() {
  return /** @type{?proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest, 12));
};


/**
 * @param {?proto.ClientServer.PvpGamesBackgammonDoublingCubeRequest|undefined} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
*/
proto.ClientServer.GameCommandRequest.prototype.setPvpGamesBackgammonDoublingCubeRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.ClientServer.GameCommandRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.clearPvpGamesBackgammonDoublingCubeRequest = function() {
  return this.setPvpGamesBackgammonDoublingCubeRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandRequest.prototype.hasPvpGamesBackgammonDoublingCubeRequest = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional PvpGamesListTournamentsRequest pvp_games_list_tournaments_request = 13;
 * @return {?proto.ClientServer.PvpGamesListTournamentsRequest}
 */
proto.ClientServer.GameCommandRequest.prototype.getPvpGamesListTournamentsRequest = function() {
  return /** @type{?proto.ClientServer.PvpGamesListTournamentsRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesListTournamentsRequest, 13));
};


/**
 * @param {?proto.ClientServer.PvpGamesListTournamentsRequest|undefined} value
 * @return {!proto.ClientServer.GameCommandRequest} returns this
*/
proto.ClientServer.GameCommandRequest.prototype.setPvpGamesListTournamentsRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.ClientServer.GameCommandRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandRequest} returns this
 */
proto.ClientServer.GameCommandRequest.prototype.clearPvpGamesListTournamentsRequest = function() {
  return this.setPvpGamesListTournamentsRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandRequest.prototype.hasPvpGamesListTournamentsRequest = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PingRequest}
 */
proto.ClientServer.PingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PingRequest;
  return proto.ClientServer.PingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PingRequest}
 */
proto.ClientServer.PingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.PingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.PingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.PingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.PingResponse}
 */
proto.ClientServer.PingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.PingResponse;
  return proto.ClientServer.PingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.PingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.PingResponse}
 */
proto.ClientServer.PingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.PingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.PingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.PingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.PingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.SetPlayerPrefsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.SetPlayerPrefsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.SetPlayerPrefsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.SetPlayerPrefsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    avatar: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.SetPlayerPrefsRequest}
 */
proto.ClientServer.SetPlayerPrefsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.SetPlayerPrefsRequest;
  return proto.ClientServer.SetPlayerPrefsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.SetPlayerPrefsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.SetPlayerPrefsRequest}
 */
proto.ClientServer.SetPlayerPrefsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatar(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.SetPlayerPrefsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.SetPlayerPrefsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.SetPlayerPrefsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.SetPlayerPrefsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvatar();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string avatar = 1;
 * @return {string}
 */
proto.ClientServer.SetPlayerPrefsRequest.prototype.getAvatar = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.SetPlayerPrefsRequest} returns this
 */
proto.ClientServer.SetPlayerPrefsRequest.prototype.setAvatar = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.SetPlayerPrefsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.SetPlayerPrefsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.SetPlayerPrefsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.SetPlayerPrefsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.SetPlayerPrefsResponse}
 */
proto.ClientServer.SetPlayerPrefsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.SetPlayerPrefsResponse;
  return proto.ClientServer.SetPlayerPrefsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.SetPlayerPrefsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.SetPlayerPrefsResponse}
 */
proto.ClientServer.SetPlayerPrefsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.SetPlayerPrefsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.SetPlayerPrefsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.SetPlayerPrefsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.SetPlayerPrefsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ClientServer.GameCommandResponse.oneofGroups_ = [[2,3,4,5,6,7,8,9,10,11,12,13]];

/**
 * @enum {number}
 */
proto.ClientServer.GameCommandResponse.ResponseCase = {
  RESPONSE_NOT_SET: 0,
  PVP_GAMES_LIST_USERS_RESPONSE: 2,
  PVP_GAMES_INVITE_OPPONENT_RESPONSE: 3,
  PVP_GAMES_ACCEPT_INVITATION_RESPONSE: 4,
  PVP_GAMES_LIST_ROOMS_RESPONSE: 5,
  PVP_GAMES_WATCH_ROOM_RESPONSE: 6,
  PVP_GAMES_PLAY_ROOM_RESPONSE: 7,
  PVP_GAMES_POKER_BET_RESPONSE: 8,
  PVP_GAMES_EXIT_ROOM_RESPONSE: 9,
  PVP_GAMES_BACKGAMMON_ROLL_RESPONSE: 10,
  PVP_GAMES_BACKGAMMON_MOVE_RESPONSE: 11,
  PVP_GAMES_BACKGAMMON_DOUBLING_CUBE_RESPONSE: 12,
  PVP_GAMES_LIST_TOURNAMENTS_RESPONSE: 13
};

/**
 * @return {proto.ClientServer.GameCommandResponse.ResponseCase}
 */
proto.ClientServer.GameCommandResponse.prototype.getResponseCase = function() {
  return /** @type {proto.ClientServer.GameCommandResponse.ResponseCase} */(jspb.Message.computeOneofCase(this, proto.ClientServer.GameCommandResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.GameCommandResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.GameCommandResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.GameCommandResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.GameCommandResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    gameId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pvpGamesListUsersResponse: (f = msg.getPvpGamesListUsersResponse()) && proto.ClientServer.PvpGamesListUsersResponse.toObject(includeInstance, f),
    pvpGamesInviteOpponentResponse: (f = msg.getPvpGamesInviteOpponentResponse()) && proto.ClientServer.PvpGamesInviteOpponentResponse.toObject(includeInstance, f),
    pvpGamesAcceptInvitationResponse: (f = msg.getPvpGamesAcceptInvitationResponse()) && proto.ClientServer.PvpGamesAcceptInvitationResponse.toObject(includeInstance, f),
    pvpGamesListRoomsResponse: (f = msg.getPvpGamesListRoomsResponse()) && proto.ClientServer.PvpGamesListRoomsResponse.toObject(includeInstance, f),
    pvpGamesWatchRoomResponse: (f = msg.getPvpGamesWatchRoomResponse()) && proto.ClientServer.PvpGamesWatchRoomResponse.toObject(includeInstance, f),
    pvpGamesPlayRoomResponse: (f = msg.getPvpGamesPlayRoomResponse()) && proto.ClientServer.PvpGamesPlayRoomResponse.toObject(includeInstance, f),
    pvpGamesPokerBetResponse: (f = msg.getPvpGamesPokerBetResponse()) && proto.ClientServer.PvpGamesPokerBetResponse.toObject(includeInstance, f),
    pvpGamesExitRoomResponse: (f = msg.getPvpGamesExitRoomResponse()) && proto.ClientServer.PvpGamesExitRoomResponse.toObject(includeInstance, f),
    pvpGamesBackgammonRollResponse: (f = msg.getPvpGamesBackgammonRollResponse()) && proto.ClientServer.PvpGamesBackgammonRollResponse.toObject(includeInstance, f),
    pvpGamesBackgammonMoveResponse: (f = msg.getPvpGamesBackgammonMoveResponse()) && proto.ClientServer.PvpGamesBackgammonMoveResponse.toObject(includeInstance, f),
    pvpGamesBackgammonDoublingCubeResponse: (f = msg.getPvpGamesBackgammonDoublingCubeResponse()) && proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.toObject(includeInstance, f),
    pvpGamesListTournamentsResponse: (f = msg.getPvpGamesListTournamentsResponse()) && proto.ClientServer.PvpGamesListTournamentsResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.GameCommandResponse}
 */
proto.ClientServer.GameCommandResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.GameCommandResponse;
  return proto.ClientServer.GameCommandResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.GameCommandResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.GameCommandResponse}
 */
proto.ClientServer.GameCommandResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGameId(value);
      break;
    case 2:
      var value = new proto.ClientServer.PvpGamesListUsersResponse;
      reader.readMessage(value,proto.ClientServer.PvpGamesListUsersResponse.deserializeBinaryFromReader);
      msg.setPvpGamesListUsersResponse(value);
      break;
    case 3:
      var value = new proto.ClientServer.PvpGamesInviteOpponentResponse;
      reader.readMessage(value,proto.ClientServer.PvpGamesInviteOpponentResponse.deserializeBinaryFromReader);
      msg.setPvpGamesInviteOpponentResponse(value);
      break;
    case 4:
      var value = new proto.ClientServer.PvpGamesAcceptInvitationResponse;
      reader.readMessage(value,proto.ClientServer.PvpGamesAcceptInvitationResponse.deserializeBinaryFromReader);
      msg.setPvpGamesAcceptInvitationResponse(value);
      break;
    case 5:
      var value = new proto.ClientServer.PvpGamesListRoomsResponse;
      reader.readMessage(value,proto.ClientServer.PvpGamesListRoomsResponse.deserializeBinaryFromReader);
      msg.setPvpGamesListRoomsResponse(value);
      break;
    case 6:
      var value = new proto.ClientServer.PvpGamesWatchRoomResponse;
      reader.readMessage(value,proto.ClientServer.PvpGamesWatchRoomResponse.deserializeBinaryFromReader);
      msg.setPvpGamesWatchRoomResponse(value);
      break;
    case 7:
      var value = new proto.ClientServer.PvpGamesPlayRoomResponse;
      reader.readMessage(value,proto.ClientServer.PvpGamesPlayRoomResponse.deserializeBinaryFromReader);
      msg.setPvpGamesPlayRoomResponse(value);
      break;
    case 8:
      var value = new proto.ClientServer.PvpGamesPokerBetResponse;
      reader.readMessage(value,proto.ClientServer.PvpGamesPokerBetResponse.deserializeBinaryFromReader);
      msg.setPvpGamesPokerBetResponse(value);
      break;
    case 9:
      var value = new proto.ClientServer.PvpGamesExitRoomResponse;
      reader.readMessage(value,proto.ClientServer.PvpGamesExitRoomResponse.deserializeBinaryFromReader);
      msg.setPvpGamesExitRoomResponse(value);
      break;
    case 10:
      var value = new proto.ClientServer.PvpGamesBackgammonRollResponse;
      reader.readMessage(value,proto.ClientServer.PvpGamesBackgammonRollResponse.deserializeBinaryFromReader);
      msg.setPvpGamesBackgammonRollResponse(value);
      break;
    case 11:
      var value = new proto.ClientServer.PvpGamesBackgammonMoveResponse;
      reader.readMessage(value,proto.ClientServer.PvpGamesBackgammonMoveResponse.deserializeBinaryFromReader);
      msg.setPvpGamesBackgammonMoveResponse(value);
      break;
    case 12:
      var value = new proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse;
      reader.readMessage(value,proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.deserializeBinaryFromReader);
      msg.setPvpGamesBackgammonDoublingCubeResponse(value);
      break;
    case 13:
      var value = new proto.ClientServer.PvpGamesListTournamentsResponse;
      reader.readMessage(value,proto.ClientServer.PvpGamesListTournamentsResponse.deserializeBinaryFromReader);
      msg.setPvpGamesListTournamentsResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.GameCommandResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.GameCommandResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.GameCommandResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.GameCommandResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPvpGamesListUsersResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ClientServer.PvpGamesListUsersResponse.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesInviteOpponentResponse();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ClientServer.PvpGamesInviteOpponentResponse.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesAcceptInvitationResponse();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ClientServer.PvpGamesAcceptInvitationResponse.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesListRoomsResponse();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ClientServer.PvpGamesListRoomsResponse.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesWatchRoomResponse();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ClientServer.PvpGamesWatchRoomResponse.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesPlayRoomResponse();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ClientServer.PvpGamesPlayRoomResponse.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesPokerBetResponse();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ClientServer.PvpGamesPokerBetResponse.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesExitRoomResponse();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ClientServer.PvpGamesExitRoomResponse.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesBackgammonRollResponse();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ClientServer.PvpGamesBackgammonRollResponse.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesBackgammonMoveResponse();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.ClientServer.PvpGamesBackgammonMoveResponse.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesBackgammonDoublingCubeResponse();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse.serializeBinaryToWriter
    );
  }
  f = message.getPvpGamesListTournamentsResponse();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.ClientServer.PvpGamesListTournamentsResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 game_id = 1;
 * @return {number}
 */
proto.ClientServer.GameCommandResponse.prototype.getGameId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.setGameId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional PvpGamesListUsersResponse pvp_games_list_users_response = 2;
 * @return {?proto.ClientServer.PvpGamesListUsersResponse}
 */
proto.ClientServer.GameCommandResponse.prototype.getPvpGamesListUsersResponse = function() {
  return /** @type{?proto.ClientServer.PvpGamesListUsersResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesListUsersResponse, 2));
};


/**
 * @param {?proto.ClientServer.PvpGamesListUsersResponse|undefined} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
*/
proto.ClientServer.GameCommandResponse.prototype.setPvpGamesListUsersResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.ClientServer.GameCommandResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.clearPvpGamesListUsersResponse = function() {
  return this.setPvpGamesListUsersResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandResponse.prototype.hasPvpGamesListUsersResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PvpGamesInviteOpponentResponse pvp_games_invite_opponent_response = 3;
 * @return {?proto.ClientServer.PvpGamesInviteOpponentResponse}
 */
proto.ClientServer.GameCommandResponse.prototype.getPvpGamesInviteOpponentResponse = function() {
  return /** @type{?proto.ClientServer.PvpGamesInviteOpponentResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesInviteOpponentResponse, 3));
};


/**
 * @param {?proto.ClientServer.PvpGamesInviteOpponentResponse|undefined} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
*/
proto.ClientServer.GameCommandResponse.prototype.setPvpGamesInviteOpponentResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.ClientServer.GameCommandResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.clearPvpGamesInviteOpponentResponse = function() {
  return this.setPvpGamesInviteOpponentResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandResponse.prototype.hasPvpGamesInviteOpponentResponse = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PvpGamesAcceptInvitationResponse pvp_games_accept_invitation_response = 4;
 * @return {?proto.ClientServer.PvpGamesAcceptInvitationResponse}
 */
proto.ClientServer.GameCommandResponse.prototype.getPvpGamesAcceptInvitationResponse = function() {
  return /** @type{?proto.ClientServer.PvpGamesAcceptInvitationResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesAcceptInvitationResponse, 4));
};


/**
 * @param {?proto.ClientServer.PvpGamesAcceptInvitationResponse|undefined} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
*/
proto.ClientServer.GameCommandResponse.prototype.setPvpGamesAcceptInvitationResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.ClientServer.GameCommandResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.clearPvpGamesAcceptInvitationResponse = function() {
  return this.setPvpGamesAcceptInvitationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandResponse.prototype.hasPvpGamesAcceptInvitationResponse = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PvpGamesListRoomsResponse pvp_games_list_rooms_response = 5;
 * @return {?proto.ClientServer.PvpGamesListRoomsResponse}
 */
proto.ClientServer.GameCommandResponse.prototype.getPvpGamesListRoomsResponse = function() {
  return /** @type{?proto.ClientServer.PvpGamesListRoomsResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesListRoomsResponse, 5));
};


/**
 * @param {?proto.ClientServer.PvpGamesListRoomsResponse|undefined} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
*/
proto.ClientServer.GameCommandResponse.prototype.setPvpGamesListRoomsResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.ClientServer.GameCommandResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.clearPvpGamesListRoomsResponse = function() {
  return this.setPvpGamesListRoomsResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandResponse.prototype.hasPvpGamesListRoomsResponse = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PvpGamesWatchRoomResponse pvp_games_watch_room_response = 6;
 * @return {?proto.ClientServer.PvpGamesWatchRoomResponse}
 */
proto.ClientServer.GameCommandResponse.prototype.getPvpGamesWatchRoomResponse = function() {
  return /** @type{?proto.ClientServer.PvpGamesWatchRoomResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesWatchRoomResponse, 6));
};


/**
 * @param {?proto.ClientServer.PvpGamesWatchRoomResponse|undefined} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
*/
proto.ClientServer.GameCommandResponse.prototype.setPvpGamesWatchRoomResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.ClientServer.GameCommandResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.clearPvpGamesWatchRoomResponse = function() {
  return this.setPvpGamesWatchRoomResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandResponse.prototype.hasPvpGamesWatchRoomResponse = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional PvpGamesPlayRoomResponse pvp_games_play_room_response = 7;
 * @return {?proto.ClientServer.PvpGamesPlayRoomResponse}
 */
proto.ClientServer.GameCommandResponse.prototype.getPvpGamesPlayRoomResponse = function() {
  return /** @type{?proto.ClientServer.PvpGamesPlayRoomResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesPlayRoomResponse, 7));
};


/**
 * @param {?proto.ClientServer.PvpGamesPlayRoomResponse|undefined} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
*/
proto.ClientServer.GameCommandResponse.prototype.setPvpGamesPlayRoomResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.ClientServer.GameCommandResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.clearPvpGamesPlayRoomResponse = function() {
  return this.setPvpGamesPlayRoomResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandResponse.prototype.hasPvpGamesPlayRoomResponse = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional PvpGamesPokerBetResponse pvp_games_poker_bet_response = 8;
 * @return {?proto.ClientServer.PvpGamesPokerBetResponse}
 */
proto.ClientServer.GameCommandResponse.prototype.getPvpGamesPokerBetResponse = function() {
  return /** @type{?proto.ClientServer.PvpGamesPokerBetResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesPokerBetResponse, 8));
};


/**
 * @param {?proto.ClientServer.PvpGamesPokerBetResponse|undefined} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
*/
proto.ClientServer.GameCommandResponse.prototype.setPvpGamesPokerBetResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.ClientServer.GameCommandResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.clearPvpGamesPokerBetResponse = function() {
  return this.setPvpGamesPokerBetResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandResponse.prototype.hasPvpGamesPokerBetResponse = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional PvpGamesExitRoomResponse pvp_games_exit_room_response = 9;
 * @return {?proto.ClientServer.PvpGamesExitRoomResponse}
 */
proto.ClientServer.GameCommandResponse.prototype.getPvpGamesExitRoomResponse = function() {
  return /** @type{?proto.ClientServer.PvpGamesExitRoomResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesExitRoomResponse, 9));
};


/**
 * @param {?proto.ClientServer.PvpGamesExitRoomResponse|undefined} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
*/
proto.ClientServer.GameCommandResponse.prototype.setPvpGamesExitRoomResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.ClientServer.GameCommandResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.clearPvpGamesExitRoomResponse = function() {
  return this.setPvpGamesExitRoomResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandResponse.prototype.hasPvpGamesExitRoomResponse = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional PvpGamesBackgammonRollResponse pvp_games_backgammon_roll_response = 10;
 * @return {?proto.ClientServer.PvpGamesBackgammonRollResponse}
 */
proto.ClientServer.GameCommandResponse.prototype.getPvpGamesBackgammonRollResponse = function() {
  return /** @type{?proto.ClientServer.PvpGamesBackgammonRollResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesBackgammonRollResponse, 10));
};


/**
 * @param {?proto.ClientServer.PvpGamesBackgammonRollResponse|undefined} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
*/
proto.ClientServer.GameCommandResponse.prototype.setPvpGamesBackgammonRollResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.ClientServer.GameCommandResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.clearPvpGamesBackgammonRollResponse = function() {
  return this.setPvpGamesBackgammonRollResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandResponse.prototype.hasPvpGamesBackgammonRollResponse = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional PvpGamesBackgammonMoveResponse pvp_games_backgammon_move_response = 11;
 * @return {?proto.ClientServer.PvpGamesBackgammonMoveResponse}
 */
proto.ClientServer.GameCommandResponse.prototype.getPvpGamesBackgammonMoveResponse = function() {
  return /** @type{?proto.ClientServer.PvpGamesBackgammonMoveResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesBackgammonMoveResponse, 11));
};


/**
 * @param {?proto.ClientServer.PvpGamesBackgammonMoveResponse|undefined} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
*/
proto.ClientServer.GameCommandResponse.prototype.setPvpGamesBackgammonMoveResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.ClientServer.GameCommandResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.clearPvpGamesBackgammonMoveResponse = function() {
  return this.setPvpGamesBackgammonMoveResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandResponse.prototype.hasPvpGamesBackgammonMoveResponse = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional PvpGamesBackgammonDoublingCubeResponse pvp_games_backgammon_doubling_cube_response = 12;
 * @return {?proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse}
 */
proto.ClientServer.GameCommandResponse.prototype.getPvpGamesBackgammonDoublingCubeResponse = function() {
  return /** @type{?proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse, 12));
};


/**
 * @param {?proto.ClientServer.PvpGamesBackgammonDoublingCubeResponse|undefined} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
*/
proto.ClientServer.GameCommandResponse.prototype.setPvpGamesBackgammonDoublingCubeResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.ClientServer.GameCommandResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.clearPvpGamesBackgammonDoublingCubeResponse = function() {
  return this.setPvpGamesBackgammonDoublingCubeResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandResponse.prototype.hasPvpGamesBackgammonDoublingCubeResponse = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional PvpGamesListTournamentsResponse pvp_games_list_tournaments_response = 13;
 * @return {?proto.ClientServer.PvpGamesListTournamentsResponse}
 */
proto.ClientServer.GameCommandResponse.prototype.getPvpGamesListTournamentsResponse = function() {
  return /** @type{?proto.ClientServer.PvpGamesListTournamentsResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesListTournamentsResponse, 13));
};


/**
 * @param {?proto.ClientServer.PvpGamesListTournamentsResponse|undefined} value
 * @return {!proto.ClientServer.GameCommandResponse} returns this
*/
proto.ClientServer.GameCommandResponse.prototype.setPvpGamesListTournamentsResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.ClientServer.GameCommandResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.GameCommandResponse} returns this
 */
proto.ClientServer.GameCommandResponse.prototype.clearPvpGamesListTournamentsResponse = function() {
  return this.setPvpGamesListTournamentsResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.GameCommandResponse.prototype.hasPvpGamesListTournamentsResponse = function() {
  return jspb.Message.getField(this, 13) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ClientServer.Request.oneofGroups_ = [[4,5,6,7,8,9,10]];

/**
 * @enum {number}
 */
proto.ClientServer.Request.RequestCase = {
  REQUEST_NOT_SET: 0,
  SESSION_LOGIN_REQUEST: 4,
  SESSION_LOGIN_REQUEST2: 5,
  PLAYER_BALANCE_REQUEST: 6,
  GAME_SUBSCRIBE_REQUEST: 7,
  GAME_COMMAND_REQUEST: 8,
  PING_REQUEST: 9,
  SET_PLAYER_PREFS_REQUEST: 10
};

/**
 * @return {proto.ClientServer.Request.RequestCase}
 */
proto.ClientServer.Request.prototype.getRequestCase = function() {
  return /** @type {proto.ClientServer.Request.RequestCase} */(jspb.Message.computeOneofCase(this, proto.ClientServer.Request.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    command: jspb.Message.getFieldWithDefault(msg, 1, 0),
    clientType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    requestId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    sessionLoginRequest: (f = msg.getSessionLoginRequest()) && proto.ClientServer.SessionLoginRequest.toObject(includeInstance, f),
    sessionLoginRequest2: (f = msg.getSessionLoginRequest2()) && proto.ClientServer.SessionLoginRequest2.toObject(includeInstance, f),
    playerBalanceRequest: (f = msg.getPlayerBalanceRequest()) && proto.ClientServer.PlayerBalanceRequest.toObject(includeInstance, f),
    gameSubscribeRequest: (f = msg.getGameSubscribeRequest()) && proto.ClientServer.GameSubscribeRequest.toObject(includeInstance, f),
    gameCommandRequest: (f = msg.getGameCommandRequest()) && proto.ClientServer.GameCommandRequest.toObject(includeInstance, f),
    pingRequest: (f = msg.getPingRequest()) && proto.ClientServer.PingRequest.toObject(includeInstance, f),
    setPlayerPrefsRequest: (f = msg.getSetPlayerPrefsRequest()) && proto.ClientServer.SetPlayerPrefsRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.Request}
 */
proto.ClientServer.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.Request;
  return proto.ClientServer.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.Request}
 */
proto.ClientServer.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ClientServer.Request.MessageType} */ (reader.readEnum());
      msg.setCommand(value);
      break;
    case 2:
      var value = /** @type {!proto.ClientServer.Request.ClientType} */ (reader.readEnum());
      msg.setClientType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestId(value);
      break;
    case 4:
      var value = new proto.ClientServer.SessionLoginRequest;
      reader.readMessage(value,proto.ClientServer.SessionLoginRequest.deserializeBinaryFromReader);
      msg.setSessionLoginRequest(value);
      break;
    case 5:
      var value = new proto.ClientServer.SessionLoginRequest2;
      reader.readMessage(value,proto.ClientServer.SessionLoginRequest2.deserializeBinaryFromReader);
      msg.setSessionLoginRequest2(value);
      break;
    case 6:
      var value = new proto.ClientServer.PlayerBalanceRequest;
      reader.readMessage(value,proto.ClientServer.PlayerBalanceRequest.deserializeBinaryFromReader);
      msg.setPlayerBalanceRequest(value);
      break;
    case 7:
      var value = new proto.ClientServer.GameSubscribeRequest;
      reader.readMessage(value,proto.ClientServer.GameSubscribeRequest.deserializeBinaryFromReader);
      msg.setGameSubscribeRequest(value);
      break;
    case 8:
      var value = new proto.ClientServer.GameCommandRequest;
      reader.readMessage(value,proto.ClientServer.GameCommandRequest.deserializeBinaryFromReader);
      msg.setGameCommandRequest(value);
      break;
    case 9:
      var value = new proto.ClientServer.PingRequest;
      reader.readMessage(value,proto.ClientServer.PingRequest.deserializeBinaryFromReader);
      msg.setPingRequest(value);
      break;
    case 10:
      var value = new proto.ClientServer.SetPlayerPrefsRequest;
      reader.readMessage(value,proto.ClientServer.SetPlayerPrefsRequest.deserializeBinaryFromReader);
      msg.setSetPlayerPrefsRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommand();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getClientType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRequestId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSessionLoginRequest();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ClientServer.SessionLoginRequest.serializeBinaryToWriter
    );
  }
  f = message.getSessionLoginRequest2();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ClientServer.SessionLoginRequest2.serializeBinaryToWriter
    );
  }
  f = message.getPlayerBalanceRequest();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ClientServer.PlayerBalanceRequest.serializeBinaryToWriter
    );
  }
  f = message.getGameSubscribeRequest();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ClientServer.GameSubscribeRequest.serializeBinaryToWriter
    );
  }
  f = message.getGameCommandRequest();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ClientServer.GameCommandRequest.serializeBinaryToWriter
    );
  }
  f = message.getPingRequest();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ClientServer.PingRequest.serializeBinaryToWriter
    );
  }
  f = message.getSetPlayerPrefsRequest();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ClientServer.SetPlayerPrefsRequest.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.ClientServer.Request.MessageType = {
  MSG_SESSION_LOGIN: 0,
  MSG_SESSION_LOGIN_2: 1,
  MSG_GET_PLAYER_BALANCE: 2,
  MSG_GAME_SUBSCRIBE: 3,
  MSG_GAME_COMMAND: 4,
  MSG_INVITE_OPPONENT: 5,
  MSG_PING: 6,
  MSG_SET_PLAYER_PREFS: 7
};

/**
 * @enum {number}
 */
proto.ClientServer.Request.ClientType = {
  CLIENT_HTML5: 0
};

/**
 * optional MessageType command = 1;
 * @return {!proto.ClientServer.Request.MessageType}
 */
proto.ClientServer.Request.prototype.getCommand = function() {
  return /** @type {!proto.ClientServer.Request.MessageType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ClientServer.Request.MessageType} value
 * @return {!proto.ClientServer.Request} returns this
 */
proto.ClientServer.Request.prototype.setCommand = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ClientType client_type = 2;
 * @return {!proto.ClientServer.Request.ClientType}
 */
proto.ClientServer.Request.prototype.getClientType = function() {
  return /** @type {!proto.ClientServer.Request.ClientType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.ClientServer.Request.ClientType} value
 * @return {!proto.ClientServer.Request} returns this
 */
proto.ClientServer.Request.prototype.setClientType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 request_id = 3;
 * @return {number}
 */
proto.ClientServer.Request.prototype.getRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.Request} returns this
 */
proto.ClientServer.Request.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional SessionLoginRequest session_login_request = 4;
 * @return {?proto.ClientServer.SessionLoginRequest}
 */
proto.ClientServer.Request.prototype.getSessionLoginRequest = function() {
  return /** @type{?proto.ClientServer.SessionLoginRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.SessionLoginRequest, 4));
};


/**
 * @param {?proto.ClientServer.SessionLoginRequest|undefined} value
 * @return {!proto.ClientServer.Request} returns this
*/
proto.ClientServer.Request.prototype.setSessionLoginRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.ClientServer.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Request} returns this
 */
proto.ClientServer.Request.prototype.clearSessionLoginRequest = function() {
  return this.setSessionLoginRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Request.prototype.hasSessionLoginRequest = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional SessionLoginRequest2 session_login_request2 = 5;
 * @return {?proto.ClientServer.SessionLoginRequest2}
 */
proto.ClientServer.Request.prototype.getSessionLoginRequest2 = function() {
  return /** @type{?proto.ClientServer.SessionLoginRequest2} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.SessionLoginRequest2, 5));
};


/**
 * @param {?proto.ClientServer.SessionLoginRequest2|undefined} value
 * @return {!proto.ClientServer.Request} returns this
*/
proto.ClientServer.Request.prototype.setSessionLoginRequest2 = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.ClientServer.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Request} returns this
 */
proto.ClientServer.Request.prototype.clearSessionLoginRequest2 = function() {
  return this.setSessionLoginRequest2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Request.prototype.hasSessionLoginRequest2 = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PlayerBalanceRequest player_balance_request = 6;
 * @return {?proto.ClientServer.PlayerBalanceRequest}
 */
proto.ClientServer.Request.prototype.getPlayerBalanceRequest = function() {
  return /** @type{?proto.ClientServer.PlayerBalanceRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PlayerBalanceRequest, 6));
};


/**
 * @param {?proto.ClientServer.PlayerBalanceRequest|undefined} value
 * @return {!proto.ClientServer.Request} returns this
*/
proto.ClientServer.Request.prototype.setPlayerBalanceRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.ClientServer.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Request} returns this
 */
proto.ClientServer.Request.prototype.clearPlayerBalanceRequest = function() {
  return this.setPlayerBalanceRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Request.prototype.hasPlayerBalanceRequest = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional GameSubscribeRequest game_subscribe_request = 7;
 * @return {?proto.ClientServer.GameSubscribeRequest}
 */
proto.ClientServer.Request.prototype.getGameSubscribeRequest = function() {
  return /** @type{?proto.ClientServer.GameSubscribeRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.GameSubscribeRequest, 7));
};


/**
 * @param {?proto.ClientServer.GameSubscribeRequest|undefined} value
 * @return {!proto.ClientServer.Request} returns this
*/
proto.ClientServer.Request.prototype.setGameSubscribeRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.ClientServer.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Request} returns this
 */
proto.ClientServer.Request.prototype.clearGameSubscribeRequest = function() {
  return this.setGameSubscribeRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Request.prototype.hasGameSubscribeRequest = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional GameCommandRequest game_command_request = 8;
 * @return {?proto.ClientServer.GameCommandRequest}
 */
proto.ClientServer.Request.prototype.getGameCommandRequest = function() {
  return /** @type{?proto.ClientServer.GameCommandRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.GameCommandRequest, 8));
};


/**
 * @param {?proto.ClientServer.GameCommandRequest|undefined} value
 * @return {!proto.ClientServer.Request} returns this
*/
proto.ClientServer.Request.prototype.setGameCommandRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.ClientServer.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Request} returns this
 */
proto.ClientServer.Request.prototype.clearGameCommandRequest = function() {
  return this.setGameCommandRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Request.prototype.hasGameCommandRequest = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional PingRequest ping_request = 9;
 * @return {?proto.ClientServer.PingRequest}
 */
proto.ClientServer.Request.prototype.getPingRequest = function() {
  return /** @type{?proto.ClientServer.PingRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PingRequest, 9));
};


/**
 * @param {?proto.ClientServer.PingRequest|undefined} value
 * @return {!proto.ClientServer.Request} returns this
*/
proto.ClientServer.Request.prototype.setPingRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.ClientServer.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Request} returns this
 */
proto.ClientServer.Request.prototype.clearPingRequest = function() {
  return this.setPingRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Request.prototype.hasPingRequest = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional SetPlayerPrefsRequest set_player_prefs_request = 10;
 * @return {?proto.ClientServer.SetPlayerPrefsRequest}
 */
proto.ClientServer.Request.prototype.getSetPlayerPrefsRequest = function() {
  return /** @type{?proto.ClientServer.SetPlayerPrefsRequest} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.SetPlayerPrefsRequest, 10));
};


/**
 * @param {?proto.ClientServer.SetPlayerPrefsRequest|undefined} value
 * @return {!proto.ClientServer.Request} returns this
*/
proto.ClientServer.Request.prototype.setSetPlayerPrefsRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.ClientServer.Request.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Request} returns this
 */
proto.ClientServer.Request.prototype.clearSetPlayerPrefsRequest = function() {
  return this.setSetPlayerPrefsRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Request.prototype.hasSetPlayerPrefsRequest = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.Error.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.Error.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.Error} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.Error.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    description: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.Error}
 */
proto.ClientServer.Error.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.Error;
  return proto.ClientServer.Error.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.Error} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.Error}
 */
proto.ClientServer.Error.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.Error.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.Error.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.Error} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.Error.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.ClientServer.Error.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.Error} returns this
 */
proto.ClientServer.Error.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.ClientServer.Error.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ClientServer.Error} returns this
 */
proto.ClientServer.Error.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ClientServer.Notification.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.ClientServer.Notification.NotificationCase = {
  NOTIFICATION_NOT_SET: 0,
  PVP_GAMES_ROOM_NOTIFICATION: 1,
  PLAYER_BALANCE_CHANGE_NOTIFICATION: 2,
  USER_DISCONNECT_NOTIFICATION: 3
};

/**
 * @return {proto.ClientServer.Notification.NotificationCase}
 */
proto.ClientServer.Notification.prototype.getNotificationCase = function() {
  return /** @type {proto.ClientServer.Notification.NotificationCase} */(jspb.Message.computeOneofCase(this, proto.ClientServer.Notification.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.Notification.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.Notification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.Notification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.Notification.toObject = function(includeInstance, msg) {
  var f, obj = {
    pvpGamesRoomNotification: (f = msg.getPvpGamesRoomNotification()) && proto.ClientServer.PvpGamesRoomNotification.toObject(includeInstance, f),
    playerBalanceChangeNotification: (f = msg.getPlayerBalanceChangeNotification()) && proto.ClientServer.PlayerBalanceChangeNotification.toObject(includeInstance, f),
    userDisconnectNotification: (f = msg.getUserDisconnectNotification()) && proto.ClientServer.UserDisconnectNotification.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.Notification}
 */
proto.ClientServer.Notification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.Notification;
  return proto.ClientServer.Notification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.Notification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.Notification}
 */
proto.ClientServer.Notification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.ClientServer.PvpGamesRoomNotification;
      reader.readMessage(value,proto.ClientServer.PvpGamesRoomNotification.deserializeBinaryFromReader);
      msg.setPvpGamesRoomNotification(value);
      break;
    case 2:
      var value = new proto.ClientServer.PlayerBalanceChangeNotification;
      reader.readMessage(value,proto.ClientServer.PlayerBalanceChangeNotification.deserializeBinaryFromReader);
      msg.setPlayerBalanceChangeNotification(value);
      break;
    case 3:
      var value = new proto.ClientServer.UserDisconnectNotification;
      reader.readMessage(value,proto.ClientServer.UserDisconnectNotification.deserializeBinaryFromReader);
      msg.setUserDisconnectNotification(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.Notification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.Notification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.Notification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.Notification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPvpGamesRoomNotification();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.ClientServer.PvpGamesRoomNotification.serializeBinaryToWriter
    );
  }
  f = message.getPlayerBalanceChangeNotification();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ClientServer.PlayerBalanceChangeNotification.serializeBinaryToWriter
    );
  }
  f = message.getUserDisconnectNotification();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ClientServer.UserDisconnectNotification.serializeBinaryToWriter
    );
  }
};


/**
 * optional PvpGamesRoomNotification pvp_games_room_notification = 1;
 * @return {?proto.ClientServer.PvpGamesRoomNotification}
 */
proto.ClientServer.Notification.prototype.getPvpGamesRoomNotification = function() {
  return /** @type{?proto.ClientServer.PvpGamesRoomNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PvpGamesRoomNotification, 1));
};


/**
 * @param {?proto.ClientServer.PvpGamesRoomNotification|undefined} value
 * @return {!proto.ClientServer.Notification} returns this
*/
proto.ClientServer.Notification.prototype.setPvpGamesRoomNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.ClientServer.Notification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Notification} returns this
 */
proto.ClientServer.Notification.prototype.clearPvpGamesRoomNotification = function() {
  return this.setPvpGamesRoomNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Notification.prototype.hasPvpGamesRoomNotification = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PlayerBalanceChangeNotification player_balance_change_notification = 2;
 * @return {?proto.ClientServer.PlayerBalanceChangeNotification}
 */
proto.ClientServer.Notification.prototype.getPlayerBalanceChangeNotification = function() {
  return /** @type{?proto.ClientServer.PlayerBalanceChangeNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PlayerBalanceChangeNotification, 2));
};


/**
 * @param {?proto.ClientServer.PlayerBalanceChangeNotification|undefined} value
 * @return {!proto.ClientServer.Notification} returns this
*/
proto.ClientServer.Notification.prototype.setPlayerBalanceChangeNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.ClientServer.Notification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Notification} returns this
 */
proto.ClientServer.Notification.prototype.clearPlayerBalanceChangeNotification = function() {
  return this.setPlayerBalanceChangeNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Notification.prototype.hasPlayerBalanceChangeNotification = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UserDisconnectNotification user_disconnect_notification = 3;
 * @return {?proto.ClientServer.UserDisconnectNotification}
 */
proto.ClientServer.Notification.prototype.getUserDisconnectNotification = function() {
  return /** @type{?proto.ClientServer.UserDisconnectNotification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.UserDisconnectNotification, 3));
};


/**
 * @param {?proto.ClientServer.UserDisconnectNotification|undefined} value
 * @return {!proto.ClientServer.Notification} returns this
*/
proto.ClientServer.Notification.prototype.setUserDisconnectNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.ClientServer.Notification.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Notification} returns this
 */
proto.ClientServer.Notification.prototype.clearUserDisconnectNotification = function() {
  return this.setUserDisconnectNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Notification.prototype.hasUserDisconnectNotification = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.ClientServer.Response.oneofGroups_ = [[3,4,5,6,7,8,9,10]];

/**
 * @enum {number}
 */
proto.ClientServer.Response.ResponseCase = {
  RESPONSE_NOT_SET: 0,
  ERROR: 3,
  NOTIFICATION: 4,
  SESSION_LOGIN_RESPONSE: 5,
  PLAYER_BALANCE_RESPONSE: 6,
  GAME_SUBSCRIBE_RESPONSE: 7,
  GAME_COMMAND_RESPONSE: 8,
  PING_RESPONSE: 9,
  SET_PLAYER_PREFS_RESPONSE: 10
};

/**
 * @return {proto.ClientServer.Response.ResponseCase}
 */
proto.ClientServer.Response.prototype.getResponseCase = function() {
  return /** @type {proto.ClientServer.Response.ResponseCase} */(jspb.Message.computeOneofCase(this, proto.ClientServer.Response.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ClientServer.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.ClientServer.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClientServer.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    disconnect: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    error: (f = msg.getError()) && proto.ClientServer.Error.toObject(includeInstance, f),
    notification: (f = msg.getNotification()) && proto.ClientServer.Notification.toObject(includeInstance, f),
    sessionLoginResponse: (f = msg.getSessionLoginResponse()) && proto.ClientServer.SessionLoginResponse.toObject(includeInstance, f),
    playerBalanceResponse: (f = msg.getPlayerBalanceResponse()) && proto.ClientServer.PlayerBalanceResponse.toObject(includeInstance, f),
    gameSubscribeResponse: (f = msg.getGameSubscribeResponse()) && proto.ClientServer.GameSubscribeResponse.toObject(includeInstance, f),
    gameCommandResponse: (f = msg.getGameCommandResponse()) && proto.ClientServer.GameCommandResponse.toObject(includeInstance, f),
    pingResponse: (f = msg.getPingResponse()) && proto.ClientServer.PingResponse.toObject(includeInstance, f),
    setPlayerPrefsResponse: (f = msg.getSetPlayerPrefsResponse()) && proto.ClientServer.SetPlayerPrefsResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClientServer.Response}
 */
proto.ClientServer.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ClientServer.Response;
  return proto.ClientServer.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClientServer.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClientServer.Response}
 */
proto.ClientServer.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisconnect(value);
      break;
    case 3:
      var value = new proto.ClientServer.Error;
      reader.readMessage(value,proto.ClientServer.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 4:
      var value = new proto.ClientServer.Notification;
      reader.readMessage(value,proto.ClientServer.Notification.deserializeBinaryFromReader);
      msg.setNotification(value);
      break;
    case 5:
      var value = new proto.ClientServer.SessionLoginResponse;
      reader.readMessage(value,proto.ClientServer.SessionLoginResponse.deserializeBinaryFromReader);
      msg.setSessionLoginResponse(value);
      break;
    case 6:
      var value = new proto.ClientServer.PlayerBalanceResponse;
      reader.readMessage(value,proto.ClientServer.PlayerBalanceResponse.deserializeBinaryFromReader);
      msg.setPlayerBalanceResponse(value);
      break;
    case 7:
      var value = new proto.ClientServer.GameSubscribeResponse;
      reader.readMessage(value,proto.ClientServer.GameSubscribeResponse.deserializeBinaryFromReader);
      msg.setGameSubscribeResponse(value);
      break;
    case 8:
      var value = new proto.ClientServer.GameCommandResponse;
      reader.readMessage(value,proto.ClientServer.GameCommandResponse.deserializeBinaryFromReader);
      msg.setGameCommandResponse(value);
      break;
    case 9:
      var value = new proto.ClientServer.PingResponse;
      reader.readMessage(value,proto.ClientServer.PingResponse.deserializeBinaryFromReader);
      msg.setPingResponse(value);
      break;
    case 10:
      var value = new proto.ClientServer.SetPlayerPrefsResponse;
      reader.readMessage(value,proto.ClientServer.SetPlayerPrefsResponse.deserializeBinaryFromReader);
      msg.setSetPlayerPrefsResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ClientServer.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ClientServer.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClientServer.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ClientServer.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDisconnect();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.ClientServer.Error.serializeBinaryToWriter
    );
  }
  f = message.getNotification();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.ClientServer.Notification.serializeBinaryToWriter
    );
  }
  f = message.getSessionLoginResponse();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.ClientServer.SessionLoginResponse.serializeBinaryToWriter
    );
  }
  f = message.getPlayerBalanceResponse();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.ClientServer.PlayerBalanceResponse.serializeBinaryToWriter
    );
  }
  f = message.getGameSubscribeResponse();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.ClientServer.GameSubscribeResponse.serializeBinaryToWriter
    );
  }
  f = message.getGameCommandResponse();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.ClientServer.GameCommandResponse.serializeBinaryToWriter
    );
  }
  f = message.getPingResponse();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.ClientServer.PingResponse.serializeBinaryToWriter
    );
  }
  f = message.getSetPlayerPrefsResponse();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.ClientServer.SetPlayerPrefsResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 request_id = 1;
 * @return {number}
 */
proto.ClientServer.Response.prototype.getRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.ClientServer.Response} returns this
 */
proto.ClientServer.Response.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool disconnect = 2;
 * @return {boolean}
 */
proto.ClientServer.Response.prototype.getDisconnect = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.ClientServer.Response} returns this
 */
proto.ClientServer.Response.prototype.setDisconnect = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Error error = 3;
 * @return {?proto.ClientServer.Error}
 */
proto.ClientServer.Response.prototype.getError = function() {
  return /** @type{?proto.ClientServer.Error} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.Error, 3));
};


/**
 * @param {?proto.ClientServer.Error|undefined} value
 * @return {!proto.ClientServer.Response} returns this
*/
proto.ClientServer.Response.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.ClientServer.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Response} returns this
 */
proto.ClientServer.Response.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Response.prototype.hasError = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Notification notification = 4;
 * @return {?proto.ClientServer.Notification}
 */
proto.ClientServer.Response.prototype.getNotification = function() {
  return /** @type{?proto.ClientServer.Notification} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.Notification, 4));
};


/**
 * @param {?proto.ClientServer.Notification|undefined} value
 * @return {!proto.ClientServer.Response} returns this
*/
proto.ClientServer.Response.prototype.setNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.ClientServer.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Response} returns this
 */
proto.ClientServer.Response.prototype.clearNotification = function() {
  return this.setNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Response.prototype.hasNotification = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional SessionLoginResponse session_login_response = 5;
 * @return {?proto.ClientServer.SessionLoginResponse}
 */
proto.ClientServer.Response.prototype.getSessionLoginResponse = function() {
  return /** @type{?proto.ClientServer.SessionLoginResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.SessionLoginResponse, 5));
};


/**
 * @param {?proto.ClientServer.SessionLoginResponse|undefined} value
 * @return {!proto.ClientServer.Response} returns this
*/
proto.ClientServer.Response.prototype.setSessionLoginResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.ClientServer.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Response} returns this
 */
proto.ClientServer.Response.prototype.clearSessionLoginResponse = function() {
  return this.setSessionLoginResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Response.prototype.hasSessionLoginResponse = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PlayerBalanceResponse player_balance_response = 6;
 * @return {?proto.ClientServer.PlayerBalanceResponse}
 */
proto.ClientServer.Response.prototype.getPlayerBalanceResponse = function() {
  return /** @type{?proto.ClientServer.PlayerBalanceResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PlayerBalanceResponse, 6));
};


/**
 * @param {?proto.ClientServer.PlayerBalanceResponse|undefined} value
 * @return {!proto.ClientServer.Response} returns this
*/
proto.ClientServer.Response.prototype.setPlayerBalanceResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.ClientServer.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Response} returns this
 */
proto.ClientServer.Response.prototype.clearPlayerBalanceResponse = function() {
  return this.setPlayerBalanceResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Response.prototype.hasPlayerBalanceResponse = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional GameSubscribeResponse game_subscribe_response = 7;
 * @return {?proto.ClientServer.GameSubscribeResponse}
 */
proto.ClientServer.Response.prototype.getGameSubscribeResponse = function() {
  return /** @type{?proto.ClientServer.GameSubscribeResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.GameSubscribeResponse, 7));
};


/**
 * @param {?proto.ClientServer.GameSubscribeResponse|undefined} value
 * @return {!proto.ClientServer.Response} returns this
*/
proto.ClientServer.Response.prototype.setGameSubscribeResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.ClientServer.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Response} returns this
 */
proto.ClientServer.Response.prototype.clearGameSubscribeResponse = function() {
  return this.setGameSubscribeResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Response.prototype.hasGameSubscribeResponse = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional GameCommandResponse game_command_response = 8;
 * @return {?proto.ClientServer.GameCommandResponse}
 */
proto.ClientServer.Response.prototype.getGameCommandResponse = function() {
  return /** @type{?proto.ClientServer.GameCommandResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.GameCommandResponse, 8));
};


/**
 * @param {?proto.ClientServer.GameCommandResponse|undefined} value
 * @return {!proto.ClientServer.Response} returns this
*/
proto.ClientServer.Response.prototype.setGameCommandResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.ClientServer.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Response} returns this
 */
proto.ClientServer.Response.prototype.clearGameCommandResponse = function() {
  return this.setGameCommandResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Response.prototype.hasGameCommandResponse = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional PingResponse ping_response = 9;
 * @return {?proto.ClientServer.PingResponse}
 */
proto.ClientServer.Response.prototype.getPingResponse = function() {
  return /** @type{?proto.ClientServer.PingResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.PingResponse, 9));
};


/**
 * @param {?proto.ClientServer.PingResponse|undefined} value
 * @return {!proto.ClientServer.Response} returns this
*/
proto.ClientServer.Response.prototype.setPingResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.ClientServer.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Response} returns this
 */
proto.ClientServer.Response.prototype.clearPingResponse = function() {
  return this.setPingResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Response.prototype.hasPingResponse = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional SetPlayerPrefsResponse set_player_prefs_response = 10;
 * @return {?proto.ClientServer.SetPlayerPrefsResponse}
 */
proto.ClientServer.Response.prototype.getSetPlayerPrefsResponse = function() {
  return /** @type{?proto.ClientServer.SetPlayerPrefsResponse} */ (
    jspb.Message.getWrapperField(this, proto.ClientServer.SetPlayerPrefsResponse, 10));
};


/**
 * @param {?proto.ClientServer.SetPlayerPrefsResponse|undefined} value
 * @return {!proto.ClientServer.Response} returns this
*/
proto.ClientServer.Response.prototype.setSetPlayerPrefsResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.ClientServer.Response.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.ClientServer.Response} returns this
 */
proto.ClientServer.Response.prototype.clearSetPlayerPrefsResponse = function() {
  return this.setSetPlayerPrefsResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ClientServer.Response.prototype.hasSetPlayerPrefsResponse = function() {
  return jspb.Message.getField(this, 10) != null;
};


goog.object.extend(exports, proto.ClientServer);
